import { Tabs, TabsContent, TabsList, TabsTrigger } from './ui/tabs';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Trash2, Upload, Plus, Database, Layers, Zap, Eye, EyeOff } from 'lucide-react';
import { SelectWithSearch } from './ui/select-with-search';
import api from '../services/api';
import { authService } from '../services/authService';
import { useToast } from '../hooks/use-toast';
import { Card } from './ui/card';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { Button } from './ui/button';
import { Switch } from './ui/switch';
import { Label } from './ui/label';
import SintisLogo from '../assets/Sintis_Logo.png';
import EvolutionApiConnection from './InstanceApiConnection';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { Dialog, DialogClose, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle, DialogTrigger } from './ui/dialog';
import { EmpresasTable } from './empresas/EmpresasTable';
import { UsuariosTable } from './usuarios/UsuariosTable';
import { FilasTable } from './filas/FilasTable';
import { TagsTable } from './tags/TagsTable';
import { ContatosTable } from './contatos/ContatosTable';
import HistoricoZproDialog from './contatos/HistoricoZproDialog';
import { useZproHabilitado } from './contatos/useZproHabilitado';
import ZproHistoricoConfig from './integrations/ZproHistoricoConfig';
import { MensagensRapidasTable } from './mensagensRapidas/MensagensRapidasTable';
import InstanceApiConnection from './InstanceApiConnection';
import { ScrollArea } from '../components/ui/scroll-area';
import SuperAdminSqlQuery from './superadmin/SuperAdminSqlQuery';
import RetencaoMidiasConfig from './superadmin/RetencaoMidiasConfig';
import ExclusaoDadosConfig from './superadmin/ExclusaoDadosConfig';
import ExcluirEmpresaModal, { DadosExclusaoEmpresa } from './superadmin/ExcluirEmpresaModal';
import MetaProviderConfigForm from './superadmin/MetaProviderConfigForm';
import MetaConfigForm from './integrations/MetaConfigForm';
import { MensagensAgendadasTable } from './mensagensAgendadas/MensagensAgendadasTable';
import HorarioAtendimentoConfig from './HorarioAtendimentoConfig';
import ConfiguracaoBackupEmpresa, { ConfiguracaoBackupState, defaultConfiguracaoBackup } from './ConfiguracaoBackupEmpresa';
import ConfiguracaoSessaoConfig from './ConfiguracaoSessaoConfig';
import PainelTvConfig from './PainelTvConfig';

type ConfigCategory = 'general' | 'appearance' | 'business-hours' | 'chat' | 'notifications' | 'integrations' | 'tenants' | 'users' | 'queues' | 'instances' | 'n8n' | 'zpro' | 'files' | 'theme' | 'colors' | 'logo' | 'business-days' | 'business-hours' | 'notifications-sounds' | 'notifications-desktop' | 'notifications-email' | 'configurations' | 'contacts' | 'tags' | 'mensagens-rapidas' | 'superadmin' | 'meta-provider-config' | 'retencao-midias' | 'exclusao-dados' | 'meta-config' | 'disparo-automatico' | 'disparo-em-bloco' | 'session' | 'painel-tv';

interface CategoryItem {
  id: ConfigCategory;
  label: string;
  icon: React.ElementType;
  color: string;
  parent?: ConfigCategory;
}

interface DayConfig {
  ativo: boolean;
  inicio?: string;
  fim?: string;
}

type WeekDay = 'segunda' | 'terca' | 'quarta' | 'quinta' | 'sexta' | 'sabado' | 'domingo';

const weekDays: WeekDay[] = ['segunda', 'terca', 'quarta', 'quinta', 'sexta', 'sabado', 'domingo'];

interface FormValues {
  nome?: string;
  logoUrl?: string;
  corPrimaria?: string;
  corSecundaria?: string;
  mensagemBoasVindas?: string;
  horarioAtendimento?: Record<WeekDay, DayConfig>;
  notificacoes?: {
    novoAtendimento: boolean;
    mensagemRecebida: boolean;
    atendimentoTransferido: boolean;
    atendimentoEncerrado: boolean;
    email: boolean;
    desktop: boolean;
    som: boolean;
  };
  integracoes?: string;
}

const FormConfiguracoes: React.FC<{
  empresaId: string;
  category: CategoryItem;
}> = ({ empresaId, category }) => {
  const { t } = useTranslation();
  const user = authService.getCurrentUser();
  console.log('[FORMCONFIG] MONTOU. category recebida:', { id: category?.id, label: category?.label, keys: Object.keys(category) });
  const { toast } = useToast();
  const [formValues, setFormValues] = useState<FormValues>({});
  const [loading, setLoading] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [showEmpresaModal, setShowEmpresaModal] = useState(false);
  const [showUsuarioModal, setShowUsuarioModal] = useState(false);
  const [showFilaModal, setShowFilaModal] = useState(false);
  const [empresas, setEmpresas] = useState<any[]>([]);
  const [empresasFiltroUsuarios, setEmpresasFiltroUsuarios] = useState<any[]>([]);
  const [usuarios, setUsuarios] = useState<any[]>([]);
  const [filas, setFilas] = useState<any[]>([]);
  const [filasEmpresa, setFilasEmpresa] = useState<any[]>([]);
  const [tables, setTables] = useState<any[]>([]);
  const [previewImage, setPreviewImage] = useState<string | null>(null);
  const [empresaFile, setEmpresaFile] = useState<File | null>(null);
  const [nome, setNome] = useState('');
  const [nomeEmpresa, setNomeEmpresa] = useState('');
  const [corPrimaria, setCorPrimaria] = useState('#000000');
  const [corSecundaria, setCorSecundaria] = useState('#FFFFFF');
  const [ativoEmpresa, setAtivoEmpresa] = useState(true);
  // Limites da empresa ('' = ilimitado)
  const [limiteInstancias, setLimiteInstancias] = useState('');
  const [limiteUsuarios, setLimiteUsuarios] = useState('');
  const [backupConfig, setBackupConfig] = useState<ConfiguracaoBackupState>(defaultConfiguracaoBackup);
  const [testandoConexaoBackup, setTestandoConexaoBackup] = useState(false);
  const [executandoBackupAgora, setExecutandoBackupAgora] = useState(false);
  const [empresa, setEmpresa] = useState('');
  const [nomeFila, setNomeFila] = useState('');
  const [indiceFila, setIndiceFila] = useState<number | ''>('');
  const [statusFila, setStatusFila] = useState(true);
  const [empresaIdEdit, setEmpresaIdEdit] = useState('');
  const [filaIdEdit, setFilaIdEdit] = useState('');
  const [usuarioIdEdit, setUsuarioIdEdit] = useState('');
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [tipoModalConfirmacao, setTipoModalConfirmacao] = useState('');
  const [idModalConfirmacao, setIdModalConfirmacao] = useState('');
  // Empresa com registros vinculados: abre o modal de exclusão completa
  const [exclusaoCompleta, setExclusaoCompleta] = useState<DadosExclusaoEmpresa | null>(null);
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [mostrarSenha, setMostrarSenha] = useState(false);
  const [role, setRole] = useState('');
  const [ativo, setAtivo] = useState(true);
  // Admin "diretor": vê todas as instâncias confidenciais (só o SuperAdmin altera — issue #26)
  const [acessoConfidencialTotal, setAcessoConfidencialTotal] = useState(false);
  const [acessoConfidencialOriginal, setAcessoConfidencialOriginal] = useState(false);
  const [filasUsuario, setFilasUsuario] = useState<any[]>([]);

  const [tags, setTags] = useState<any[]>([]);
  const [showTagModal, setShowTagModal] = useState(false);
  const [tagIdEdit, setTagIdEdit] = useState('');
  const [tituloTag, setTituloTag] = useState('');
  const [corTag, setCorTag] = useState('#000000');
  const [prioridadeTag, setPrioridadeTag] = useState('');
  const [ativoTag, setAtivoTag] = useState(false);

  // Mensagens Rápidas states
  const [mensagensRapidas, setMensagensRapidas] = useState<any[]>([]);
  const [showMensagemRapidaModal, setShowMensagemRapidaModal] = useState(false);
  const [mensagemRapidaEdit, setMensagemRapidaEdit] = useState<any>(null);
  const [mensagensRapidasPage, setMensagensRapidasPage] = useState(0);
  const [mensagensRapidasRowsPerPage, setMensagensRapidasRowsPerPage] = useState(10);
  const [mensagensRapidasSearch, setMensagensRapidasSearch] = useState('');
  const [mensagensRapidasSort, setMensagensRapidasSort] = useState({ field: 'chave', order: 'asc' as 'asc' | 'desc' });
  const [mensagensRapidasTotal, setMensagensRapidasTotal] = useState(0);
  const [categoriasMensagensRapidas, setCategoriasMensagensRapidas] = useState<any[]>([]);
  const [showCategoriaModal, setShowCategoriaModal] = useState(false);
  const [showGerenciarCategorias, setShowGerenciarCategorias] = useState(false);
  const [categoriaEdit, setCategoriaEdit] = useState<any>(null);
  const [anexosMensagemRapida, setAnexosMensagemRapida] = useState<any[]>([]);
  const [blocoEditMensagens, setBlocoEditMensagens] = useState<any>(null);
  const [blocoEditMensagensMsgIds, setBlocoEditMensagensMsgIds] = useState<string[]>([]);

  // Pagination states
  const [empresasPage, setEmpresasPage] = useState(0);
  const [empresasRowsPerPage, setEmpresasRowsPerPage] = useState(10);
  const [empresasSearch, setEmpresasSearch] = useState('');
  const [empresasSort, setEmpresasSort] = useState({ field: 'nome', order: 'asc' as 'asc' | 'desc' });

  const [usuariosPage, setUsuariosPage] = useState(0);
  const [usuariosRowsPerPage, setUsuariosRowsPerPage] = useState(10);
  const [usuariosSearch, setUsuariosSearch] = useState('');
  const [usuariosSort, setUsuariosSort] = useState({ field: 'nome', order: 'asc' as 'asc' | 'desc' });
  const [usuariosEmpresaFiltro, setUsuariosEmpresaFiltro] = useState('todas');

  const [filasPage, setFilasPage] = useState(0);
  const [filasRowsPerPage, setFilasRowsPerPage] = useState(10);
  const [filasSearch, setFilasSearch] = useState('');
  const [filasSort, setFilasSort] = useState({ field: 'nome', order: 'asc' as 'asc' | 'desc' });

  const [tagsPage, setTagsPage] = useState(0);
  const [tagsRowsPerPage, setTagsRowsPerPage] = useState(10);
  const [tagsSearch, setTagsSearch] = useState('');
  const [tagsSort, setTagsSort] = useState({ field: 'titulo', order: 'asc' as 'asc' | 'desc' });

  const [contatosPage, setContatosPage] = useState(0);
  const [contatosRowsPerPage, setContatosRowsPerPage] = useState(10);
  const [contatosSort, setContatosSort] = useState({ field: 'nome', order: 'asc' as 'asc' | 'desc' });

  // Totals for tables (from backend pagination)
  const [empresasTotal, setEmpresasTotal] = useState(0);
  const [usuariosTotal, setUsuariosTotal] = useState(0);
  const [filasTotal, setFilasTotal] = useState(0);
  const [contatosTotal, setContatosTotal] = useState(0);
  const [tagsTotal, setTagsTotal] = useState(0);


  // Contact states
  const [contatos, setContatos] = useState<any[]>([]);
  const [showContatoModal, setShowContatoModal] = useState(false);
  const [contatoIdEdit, setContatoIdEdit] = useState('');
  const [nomeContato, setNomeContato] = useState('');
  const [telefoneContato, setTelefoneContato] = useState('');
  const [emailContato, setEmailContato] = useState('');
  const [notasContato, setNotasContato] = useState('');
  const [searchContato, setSearchContato] = useState('');
  const [tipoContato, setTipoContato] = useState<'todos' | 'grupos' | 'normais'>('todos');
  const [instancias, setInstancias] = useState<any[]>([]);
  const [instanciaContato, setInstanciaContato] = useState('');

  // N8N configuration states
  const [n8nConfig, setN8nConfig] = useState({
    webhookUrl: '',
    webhookSecret: '',
    apiKey: '',
    enabled: false
  });
  const [loadingN8n, setLoadingN8n] = useState(false);
  const [historicoZproContato, setHistoricoZproContato] = useState<{ id: string; nome: string } | null>(null);
  const zproHabilitado = useZproHabilitado();
  const [testingN8n, setTestingN8n] = useState(false);
  const [gerandoN8nKey, setGerandoN8nKey] = useState(false);
  const [revelarN8nKey, setRevelarN8nKey] = useState(false);

  // Chat configuration states
  const [chatConfig, setChatConfig] = useState<any>(null);
  const [assinaturaAtendente, setAssinaturaAtendente] = useState(false);
  const [textoAssinatura, setTextoAssinatura] = useState('');
  const [permitirNotas, setPermitirNotas] = useState(true);
  const [permitirTags, setPermitirTags] = useState(true);
  const [usuarioPodeFinalizarTicket, setUsuarioPodeFinalizarTicket] = useState(false);
  const [usuarioPodeTransferirTicket, setUsuarioPodeTransferirTicket] = useState(false);
  const [ativarMensagemBoasVindas, setAtivarMensagemBoasVindas] = useState(false);
  const [contadorIncluirGrupos, setContadorIncluirGrupos] = useState(false);
  const [permitirTransferenciaGrupos, setPermitirTransferenciaGrupos] = useState(false);
  const [transferenciaHistoricoCompleto, setTransferenciaHistoricoCompleto] = useState(true);
  const [transferenciaInstanciaModo, setTransferenciaInstanciaModo] = useState<'MANTER' | 'PERGUNTAR' | 'TRANSFERIR'>('TRANSFERIR');
  const [baixarMidiaGruposAutomaticamente, setBaixarMidiaGruposAutomaticamente] = useState(false);
  const [exibirGruposNoPainelOperacional, setExibirGruposNoPainelOperacional] = useState(false);
  const [enviarApenasParaNovosContatos, setEnviarApenasParaNovosContatos] = useState(false);
  const [agruparChatsPorContatos, setAgruparChatsPorContatos] = useState(false);
  const [exibirFinalizadosParaTodos, setExibirFinalizadosParaTodos] = useState(false);
  const [apenasAdminVePendentes, setApenasAdminVePendentes] = useState(false);
  const [excluirGrupoApagaTickets, setExcluirGrupoApagaTickets] = useState(false);
  const [permitirKanban, setPermitirKanban] = useState(false);
  const [fecharTicketAtualizaKanban, setFecharTicketAtualizaKanban] = useState(false);
  const [usuarioPodeMoverKanban, setUsuarioPodeMoverKanban] = useState(false);
  const [tamanhoPaginaAtendimento, setTamanhoPaginaAtendimento] = useState(50);
  const API_BASE_URL = (process.env.REACT_APP_API_URL || 'http://localhost:5001')?.replace(/\/api$/, '');

  // Filas da empresa escolhida no cadastro de usuário (a lista paginada de filas não serve: é cortada em páginas)
  useEffect(() => {
    if (!empresa) {
      setFilasEmpresa([]);
      return;
    }
    let cancelado = false;
    (async () => {
      try {
        const res = await api.get('/filas', {
          params: { page: 1, pageSize: 100, sortBy: 'nome', sortOrder: 'asc', empresaId: empresa }
        });
        const data = res?.data?.filas || [];
        if (!cancelado) setFilasEmpresa(Array.isArray(data) ? data.filter((f: any) => f.empresaId === empresa) : []);
      } catch (error) {
        console.error('Erro ao carregar filas da empresa:', error);
        if (!cancelado) setFilasEmpresa([]);
      }
    })();
    return () => { cancelado = true; };
  }, [empresa]);

  const handleChange = (name: string, value: any) => {
    setFormValues(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleNestedChange = (parent: string, name: string, value: any) => {
    setFormValues(prev => ({
      ...prev,
      [parent]: {
        ...(prev[parent as keyof typeof prev] as object || {}),
        [name]: value
      }
    }));
  };

  // Funções de carregamento específicas
  const loadEmpresas = async () => {
    if (user.role !== 'SuperAdmin') return;

    try {
      setLoading(true);
      const resEmpresa = await api.get('/empresas', {
        params: {
          page: empresasPage + 1,
          pageSize: empresasRowsPerPage,
          search: empresasSearch,
          sortBy: empresasSort.field,
          sortOrder: empresasSort.order
        }
      });
      const empresasData = resEmpresa?.data?.data || resEmpresa?.data?.empresas || resEmpresa?.data || [];
      setEmpresas(Array.isArray(empresasData) ? empresasData : [empresasData].filter(Boolean));
      setEmpresasTotal(resEmpresa?.data?.pagination?.total ?? (Array.isArray(empresasData) ? empresasData.length : 0));
    } catch (error) {
      console.error('Erro ao carregar empresas:', error);
    } finally {
      setLoading(false);
    }
  };

  const loadEmpresasFiltroUsuarios = async () => {
    if (user.role !== 'SuperAdmin') return;

    try {
      // A API limita a 100 por página: percorre todas as páginas para listar todas as empresas
      const todas: any[] = [];
      let pagina = 1;
      let totalPaginas = 1;
      do {
        const res = await api.get('/empresas', {
          params: { page: pagina, pageSize: 100, sortBy: 'nome', sortOrder: 'asc' }
        });
        const data = res?.data?.data || res?.data?.empresas || res?.data || [];
        todas.push(...(Array.isArray(data) ? data : [data].filter(Boolean)));
        totalPaginas = res?.data?.pagination?.totalPages || 1;
        pagina += 1;
      } while (pagina <= totalPaginas);
      setEmpresasFiltroUsuarios(todas);
    } catch (error) {
      console.error('Erro ao carregar empresas para filtro:', error);
    }
  };

  const loadUsuarios = async () => {
    if (user.role !== 'Admin' && user.role !== 'SuperAdmin') return;

    try {
      setLoading(true);
      const resUser = await api.get('/usuarios', {
        params: {
          page: usuariosPage + 1,
          pageSize: usuariosRowsPerPage,
          search: usuariosSearch,
          sortBy: usuariosSort.field,
          sortOrder: usuariosSort.order,
          empresaId: user.role === 'SuperAdmin' && usuariosEmpresaFiltro !== 'todas' ? usuariosEmpresaFiltro : undefined
        }
      });
      const usuariosData = resUser?.data?.usuarios || resUser?.data?.data || resUser?.data || [];
      setUsuarios(Array.isArray(usuariosData) ? usuariosData : [usuariosData]);
      setUsuariosTotal(resUser?.data?.pagination?.total ?? (Array.isArray(usuariosData) ? usuariosData.length : 0));
    } catch (error) {
      console.error('Erro ao carregar usuários:', error);
    } finally {
      setLoading(false);
    }
  };

  const loadFilas = async () => {
    if (user.role !== 'Admin' && user.role !== 'SuperAdmin') return;

    try {
      setLoading(true);
      const resFila = await api.get('/filas', {
        params: {
          page: filasPage + 1,
          pageSize: filasRowsPerPage,
          search: filasSearch,
          sortBy: filasSort.field,
          sortOrder: filasSort.order
        }
      });
      const filasData = resFila?.data?.filas || resFila?.data?.data || resFila?.data || [];
      setFilas(Array.isArray(filasData) ? filasData : [filasData]);
      setFilasTotal(resFila?.data?.pagination?.total ?? (Array.isArray(filasData) ? filasData.length : 0));
    } catch (error) {
      console.error('Erro ao carregar filas:', error);
    } finally {
      setLoading(false);
    }
  };

  const loadTables = async () => {
    try {
      const response = await api.get(`/superadmin/tables`);
      setTables(response.data.tables || []);
    } catch (error) {
      console.error('Erro ao carregar tabelas:', error);
      toast({
        title: 'Erro',
        description: 'Não foi possível carregar as tabelas',
        variant: 'destructive',
      });
    }
  };

  // Função global para atualizar todas as listagens de empresas, usuários e filas
  const loadData = async () => {
    console.log('[DEBUG] FormConfiguracoes - loadData iniciado');
    setLoading(true);
    try {
      if (user.role === 'SuperAdmin') {
        console.log('[DEBUG] FormConfiguracoes - Carregando empresas (SuperAdmin)');
        await loadEmpresas();
      }
      if (user.role === 'Admin') {
        const resEmpresa = await api.get(`/empresas/${user.empresaId}`);
        const empresaData = resEmpresa?.data?.empresa || resEmpresa?.data?.data || resEmpresa?.data;
        if (empresaData?.id) {
          setEmpresa(empresaData.id);
        }
      }
      if (user.role === 'Admin' || user.role === 'SuperAdmin') {
        console.log('[DEBUG] FormConfiguracoes - Carregando filas e usuários');
        await loadFilas();
        await loadUsuarios();
      }

      // Load full companies list for the users filter combobox
      if (category.id === 'users' && user.role === 'SuperAdmin') {
        await loadEmpresasFiltroUsuarios();
      }

      // Load contacts if on contacts page
      if (category.id === 'contacts') {
        await loadContatos();
      }

      // Load tags if on tags page
      if (category.id === 'tags') {
        await loadTags();
      }

      // Load mensagens rápidas if on mensagens-rapidas page or disparo-em-bloco
      if (category.id === 'mensagens-rapidas' || category.id === 'disparo-em-bloco') {
        await loadMensagensRapidas();
        await loadCategoriasMensagensRapidas();
      }

      // Load chat config if on configurations page
      if (category.id === 'configurations') {
        await loadChatConfig();
      }

      // Load N8N config if on n8n page
      if (category.id === 'n8n') {
        await loadN8nConfig();
      }

      // Load instancias
      const resInstancias = await api.get('/instancias');
      setInstancias(resInstancias?.data.instancias || []);
    } catch (e: any) {
      toast({
        title: 'Erro ao carregar dados',
        description: extractError(e?.response?.data?.message),
        variant: 'destructive',
      });
    } finally {
      setLoading(false);
    }
  };

  const loadContatos = async () => {
    try {
      const response = await api.get(`/contatos`, {
        params: {
          page: contatosPage + 1,
          pageSize: contatosRowsPerPage,
          search: searchContato,
          tipo: tipoContato,
          sortBy: contatosSort.field === 'createdAt' ? 'dataCriacao' : contatosSort.field,
          sortOrder: contatosSort.order,
        }
      });
      const contatosData = response?.data?.contatos || response?.data?.data || response?.data || [];
      setContatos(Array.isArray(contatosData) ? contatosData : []);
      setContatosTotal(response?.data?.total ?? (Array.isArray(contatosData) ? contatosData.length : 0));
    } catch (e: any) {
      toast({
        title: 'Erro ao carregar contatos',
        description: extractError(e?.response?.data?.message),
        variant: 'destructive',
      });
    }
  };

  const loadTags = async () => {
    try {
      const response = await api.get(`/tags`, {
        params: {
          page: tagsPage + 1,
          pageSize: tagsRowsPerPage,
          search: tagsSearch,
          sortBy: tagsSort.field,
          sortOrder: tagsSort.order,
        }
      });
      // Backend retorna { data: [...], pagination: { total, ... } }
      const apiResponse = response?.data || {};
      const tagsData = apiResponse?.data || apiResponse?.tags || apiResponse || [];
      setTags(Array.isArray(tagsData) ? tagsData : []);
      setTagsTotal(apiResponse?.pagination?.total ?? (Array.isArray(tagsData) ? tagsData.length : 0));
    } catch (e: any) {
      toast({
        title: 'Erro ao carregar tags',
        description: extractError(e?.response?.data?.message),
        variant: 'destructive',
      });
    }
  };

  const loadMensagensRapidas = async () => {
    try {
      const response = await api.get(`/mensagens-rapidas`, {
        params: {
          page: mensagensRapidasPage + 1,
          pageSize: mensagensRapidasRowsPerPage,
          search: mensagensRapidasSearch,
          sortBy: mensagensRapidasSort.field,
          sortOrder: mensagensRapidasSort.order,
        }
      });

      // A API retorna um objeto paginado com 'data' e 'pagination'
      const apiResponse = response?.data || {};
      console.log('FormConfiguracoes - Quick Messages API Response:', apiResponse);
      const mensagensData = apiResponse?.data || [];
      console.log('FormConfiguracoes - Quick Messages loaded:', mensagensData);
      setMensagensRapidas(Array.isArray(mensagensData) ? mensagensData : []);
      setMensagensRapidasTotal(apiResponse?.pagination?.total ?? 0);
    } catch (e: any) {
      toast({
        title: 'Erro ao carregar mensagens rápidas',
        description: extractError(e?.response?.data?.message),
        variant: 'destructive',
      });
    }
  };

  const loadCategoriasMensagensRapidas = async () => {
    try {
      const response = await api.get('/mensagens-rapidas/categorias');
      setCategoriasMensagensRapidas(Array.isArray(response.data) ? response.data : []);
    } catch (e: any) {
      console.error('Erro ao carregar categorias:', e);
    }
  };

  const handleSubmitCategoria = async () => {
    try {
      setLoading(true);
      const empresaId = user.role === 'SuperAdmin' ? empresa : user.empresaId;
      const data = { empresaId, nome: categoriaEdit.nome };
      if (categoriaEdit.id) {
        await api.put(`/mensagens-rapidas/categorias/${categoriaEdit.id}`, data);
      } else {
        await api.post('/mensagens-rapidas/categorias', data);
      }
      await loadCategoriasMensagensRapidas();
      setCategoriaEdit(null);
      setShowCategoriaModal(false);
      toast({ title: 'Sucesso', description: 'Bloco salvo com sucesso' });
    } catch (e: any) {
      toast({ title: 'Erro', description: extractError(e?.response?.data?.message), variant: 'destructive' });
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteCategoria = async (id: string) => {
    try {
      setLoading(true);
      await api.delete(`/mensagens-rapidas/categorias/${id}`);
      await loadCategoriasMensagensRapidas();
      toast({ title: 'Sucesso', description: 'Bloco excluído com sucesso' });
    } catch (e: any) {
      toast({ title: 'Erro', description: extractError(e?.response?.data?.message), variant: 'destructive' });
    } finally {
      setLoading(false);
    }
  };

  const handleGerenciarMensagensBloco = async (bloco: any) => {
    setBlocoEditMensagens(bloco);
    // Load current message IDs for this bloco
    try {
      const response = await api.get('/mensagens-rapidas', {
        params: { blocoId: bloco.id, pageSize: 500 }
      });
      const existingMsgIds = (response?.data?.data || [])
        .filter((m: any) => m.blocos?.some((b: any) => b.bloco?.id === bloco.id || b.blocoId === bloco.id))
        .map((m: any) => m.id);
      setBlocoEditMensagensMsgIds(existingMsgIds);
    } catch (e) {
      setBlocoEditMensagensMsgIds([]);
    }
    setShowGerenciarCategorias(true);
    // Load all quick messages for selection
    await loadMensagensRapidas();
  };

  const handleSalvarMensagensBloco = async () => {
    const blocoId = blocoEditMensagens?.id;
    if (!blocoId) return;
    setLoading(true);
    try {
      // Get all messages currently in this bloco
      const response = await api.get('/mensagens-rapidas', {
        params: { blocoId, pageSize: 500 }
      });
      const currentMsgs = response?.data?.data || [];

      // Remove bloco from messages that are no longer selected
      const toRemove = currentMsgs.filter((m: any) => !blocoEditMensagensMsgIds.includes(m.id));
      for (const msg of toRemove) {
        const currentBlocoIds = (msg.blocos || [])
          .map((b: any) => b.bloco?.id || b.blocoId)
          .filter((id: string) => id !== blocoId);
        await api.put(`/mensagens-rapidas/${msg.id}`, { blocoIds: currentBlocoIds });
      }

      // Add bloco to newly selected messages
      const existingMsgIds = currentMsgs.map((m: any) => m.id);
      const toAdd = blocoEditMensagensMsgIds.filter((id: string) => !existingMsgIds.includes(id));
      for (const msgId of toAdd) {
        const msgResp = await api.get(`/mensagens-rapidas/${msgId}`);
        const msg = msgResp.data;
        const currentBlocoIds = (msg.blocos || [])
          .map((b: any) => b.bloco?.id || b.blocoId)
          .filter(Boolean);
        if (!currentBlocoIds.includes(blocoId)) {
          currentBlocoIds.push(blocoId);
        }
        await api.put(`/mensagens-rapidas/${msgId}`, { blocoIds: currentBlocoIds });
      }

      await loadCategoriasMensagensRapidas();
      toast({ title: 'Sucesso', description: 'Mensagens do bloco atualizadas' });
      setShowGerenciarCategorias(false);
      setBlocoEditMensagens(null);
    } catch (e: any) {
      toast({ title: 'Erro', description: extractError(e?.response?.data?.message), variant: 'destructive' });
    } finally {
      setLoading(false);
    }
  };

  const handleAddAnexo = () => {
    setAnexosMensagemRapida(prev => [...prev, { nome: '', url: null, tipo: 'documento' }]);
  };

  const handleRemoveAnexo = (index: number) => {
    setAnexosMensagemRapida(prev => prev.filter((_, i) => i !== index));
  };

  const handleAnexoChange = (index: number, field: string, value: string) => {
    setAnexosMensagemRapida(prev => prev.map((a, i) => i === index ? { ...a, [field]: value } : a));
  };

  const handleAnexoFileSelect = async (index: number, e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    try {
      const formData = new FormData();
      formData.append('file', file);

      const response = await api.post('/mensagens-rapidas/upload', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      const { nome, url, tipo } = response.data;
      setAnexosMensagemRapida(prev => prev.map((a, i) =>
        i === index ? { ...a, nome: nome || file.name, url, tipo: tipo || 'documento' } : a
      ));
    } catch (err: any) {
      toast({
        title: 'Erro ao enviar arquivo',
        description: err?.response?.data?.message || err.message,
        variant: 'destructive',
      });
    }
  };

  const loadChatConfig = async () => {
    try {
      const empresaId = user.role === 'SuperAdmin' ? empresa : user.empresaId;
      if (!empresaId) return;

      const response = await api.get(`/configuracoes-chat/empresa/${empresaId}`);
      const config = response?.data.configuracao;

      if (config) {
        setChatConfig(config);
        setFormValues(prev => ({
          ...prev,
          mensagemBoasVindas: config.mensagemBoasVindas || '',
        }));
        setAssinaturaAtendente(config.assinaturaAtendente);
        setTextoAssinatura(config.textoAssinatura || '');
        setPermitirNotas(config.permitirNotas);
        setPermitirTags(config.permitirTags);
        setUsuarioPodeFinalizarTicket(config.usuarioPodeFinalizarTicket);
        setUsuarioPodeTransferirTicket(config.usuarioPodeTransferirTicket);
        setAtivarMensagemBoasVindas(config.ativarMensagemBoasVindas ?? false);
        setContadorIncluirGrupos(config.contadorIncluirGrupos ?? false);
        setPermitirTransferenciaGrupos(config.permitirTransferenciaGrupos ?? false);
        setTransferenciaHistoricoCompleto(config.transferenciaHistoricoCompleto ?? true);
        setTransferenciaInstanciaModo(config.transferenciaInstanciaModo ?? 'TRANSFERIR');
        setBaixarMidiaGruposAutomaticamente(config.baixarMidiaGruposAutomaticamente ?? false);
        setExibirGruposNoPainelOperacional(config.exibirGruposNoPainelOperacional ?? false);
        setEnviarApenasParaNovosContatos(config.enviarApenasParaNovosContatos ?? false);
        setAgruparChatsPorContatos(config.agruparChatsPorContatos ?? false);
        setExibirFinalizadosParaTodos(config.exibirFinalizadosParaTodos ?? false);
        setApenasAdminVePendentes(config.apenasAdminVePendentes ?? false);
        setExcluirGrupoApagaTickets(config.excluirGrupoApagaTickets ?? false);
        setPermitirKanban(config.permitirKanban ?? false);
        setFecharTicketAtualizaKanban(config.fecharTicketAtualizaKanban ?? false);
        setUsuarioPodeMoverKanban(config.usuarioPodeMoverKanban ?? false);
        setTamanhoPaginaAtendimento(config.tamanhoPaginaAtendimento ?? 50);
      }
    } catch (e: any) {
      toast({
        title: 'Erro ao carregar configurações',
        description: extractError(e?.response?.data?.message),
        variant: 'destructive',
      });
    }
  };

  const saveChatConfig = async () => {
    try {
      setLoading(true);
      const empresaId = user.role === 'SuperAdmin' ? empresa : user.empresaId;
      if (!empresaId) return;

      const data = {
        mensagemBoasVindas: formValues.mensagemBoasVindas,
        ativarMensagemBoasVindas,
        enviarApenasParaNovosContatos,
        agruparChatsPorContatos,
        assinaturaAtendente,
        textoAssinatura,
        permitirNotas,
        permitirTags,
        usuarioPodeFinalizarTicket,
        usuarioPodeTransferirTicket,
        contadorIncluirGrupos,
        permitirTransferenciaGrupos,
        transferenciaHistoricoCompleto,
        transferenciaInstanciaModo,
        baixarMidiaGruposAutomaticamente,
        exibirGruposNoPainelOperacional,
        exibirFinalizadosParaTodos,
        apenasAdminVePendentes,
        excluirGrupoApagaTickets,
        permitirKanban,
        fecharTicketAtualizaKanban,
        usuarioPodeMoverKanban,
        tamanhoPaginaAtendimento,
      };

      await api.put(`/configuracoes-chat/empresa/${empresaId}`, data);

      toast({
        title: 'Sucesso',
        description: 'Configurações salvas com sucesso',
      });

      await loadChatConfig();
    } catch (e: any) {
      toast({
        title: 'Erro ao salvar',
        description: extractError(e?.response?.data?.message),
        variant: 'destructive',
      });
    } finally {
      setLoading(false);
    }
  };

  // N8N Configuration functions
  const loadN8nConfig = async () => {
    try {
      setLoadingN8n(true);
      const empresaId = user.role === 'SuperAdmin' ? empresa : user.empresaId;
      if (!empresaId) return;

      const response = await api.get(`/empresas/${empresaId}/n8n`);
      const config = response?.data?.data;

      if (config) {
        setN8nConfig({
          webhookUrl: config.webhookUrl || '',
          webhookSecret: config.webhookSecret || '',
          apiKey: config.apiKey || '',
          enabled: config.enabled || false
        });
      }
    } catch (e: any) {
      toast({
        title: 'Erro ao carregar configurações N8N',
        description: extractError(e?.response?.data?.message),
        variant: 'destructive',
      });
    } finally {
      setLoadingN8n(false);
    }
  };

  const saveN8nConfig = async () => {
    try {
      setLoadingN8n(true);
      const empresaId = user.role === 'SuperAdmin' ? empresa : user.empresaId;
      if (!empresaId) return;

      const data = {
        webhookUrl: n8nConfig.webhookUrl,
        webhookSecret: n8nConfig.webhookSecret,
        apiKey: n8nConfig.apiKey,
        enabled: n8nConfig.enabled
      };

      await api.put(`/empresas/${empresaId}/n8n`, data);

      toast({
        title: 'Sucesso',
        description: 'Configurações N8N salvas com sucesso',
      });

      await loadN8nConfig();
    } catch (e: any) {
      toast({
        title: 'Erro ao salvar',
        description: extractError(e?.response?.data?.message),
        variant: 'destructive',
      });
    } finally {
      setLoadingN8n(false);
    }
  };

  const testN8nConfig = async () => {
    try {
      setTestingN8n(true);
      const empresaId = user.role === 'SuperAdmin' ? empresa : user.empresaId;
      if (!empresaId) return;

      const response = await api.post(`/empresas/${empresaId}/n8n/test`);

      toast({
        title: 'Teste realizado',
        description: response?.data?.message || 'Teste enviado com sucesso',
      });
    } catch (e: any) {
      toast({
        title: 'Erro no teste',
        description: extractError(e?.response?.data?.message),
        variant: 'destructive',
      });
    } finally {
      setTestingN8n(false);
    }
  };

  const gerarN8nApiKey = async () => {
    const empresaId = user.role === 'SuperAdmin' ? empresa : user.empresaId;
    if (!empresaId) {
      toast({ title: 'Aviso', description: 'Selecione uma empresa antes de gerar a chave', variant: 'destructive' });
      return;
    }

    if (n8nConfig.apiKey === '***') {
      const ok = window.confirm(
        'Gerar uma nova chave invalida a chave atual imediatamente.\n\n' +
        'Todos os workflows do N8N que usam a chave antiga vão parar de funcionar até serem atualizados.\n\nDeseja continuar?'
      );
      if (!ok) return;
    }

    try {
      setGerandoN8nKey(true);
      const response = await api.post(`/empresas/${empresaId}/n8n/gerar-chave`);
      const novaKey = response?.data?.data?.apiKey;

      setN8nConfig(prev => ({ ...prev, apiKey: novaKey }));
      setRevelarN8nKey(true);

      if (navigator.clipboard) {
        navigator.clipboard.writeText(novaKey).catch(() => {});
      }

      toast({
        title: 'API Key gerada',
        description: 'Copie agora — ela não será exibida novamente depois de salvar.'
      });
    } catch (e: any) {
      toast({
        title: 'Erro ao gerar a API Key',
        description: extractError(e?.response?.data?.message),
        variant: 'destructive',
      });
    } finally {
      setGerandoN8nKey(false);
    }
  };

  useEffect(() => {
    console.log('[DEBUG] FormConfiguracoes - useEffect [category] - Category mudou:', category?.id);
    loadData();
  }, [category]);

  // Carregar tabelas quando empresa mudar (para SuperAdmin)
  useEffect(() => {
    console.log('[DEBUG] FormConfiguracoes - useEffect [empresa] - Empresa mudou:', empresa);
    if (user?.role === 'SuperAdmin') {
      loadTables();
    }
  }, []);

  // Recarregar empresas quando parâmetros mudarem
  useEffect(() => {
    if (category.id === 'tenants' && user.role === 'SuperAdmin') {
      console.log('[DEBUG] FormConfiguracoes - useEffect [category.id === tenants] - Carregando empresas');
      loadEmpresas();
    }
  }, [empresasPage, empresasRowsPerPage, empresasSearch, empresasSort, empresaIdEdit]);

  // Recarregar usuários quando parâmetros mudarem
  useEffect(() => {
    if (category.id === 'users' && (user.role === 'Admin' || user.role === 'SuperAdmin')) {
      loadUsuarios();
    }
  }, [usuariosSearch, usuariosSort, usuariosPage, usuariosRowsPerPage, usuarioIdEdit, usuariosEmpresaFiltro]);

  // Recarregar filas quando parâmetros mudarem
  useEffect(() => {
    if (category.id === 'queues' && (user.role === 'Admin' || user.role === 'SuperAdmin')) {
      loadFilas();
    }
  }, [filasSearch, filasSort, filasPage, filasRowsPerPage, filaIdEdit]);

  // Recarregar mensagens rápidas quando parâmetros mudarem
  useEffect(() => {
    if (category.id === 'mensagens-rapidas') {
      loadMensagensRapidas();
      loadCategoriasMensagensRapidas();
    }
  }, [mensagensRapidasSearch, mensagensRapidasSort, mensagensRapidasPage, mensagensRapidasRowsPerPage, mensagemRapidaEdit]);

  // Recarregar contatos quando parâmetros mudarem
  useEffect(() => {
    if (category.id === 'contacts') {
      loadContatos();
    }
  }, [searchContato, tipoContato, contatosSort, contatosPage, contatosRowsPerPage, contatoIdEdit]);

  // Recarregar tags quando parâmetros mudarem
  useEffect(() => {
    if (category.id === 'tags') {
      loadTags();
    }
  }, [tagsSearch, tagsSort, tagsPage, tagsRowsPerPage]);

  const montarPayloadBackupConfig = () => {
    const { ultimoBackupEm, ultimoBackupStatus, ultimoBackupMensagem, ...payload } = backupConfig;
    return payload;
  };

  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      setEmpresaFile(file);
      const reader = new FileReader();
      reader.onload = (event) => {
        if (event.target?.result) {
          setPreviewImage(event.target.result as string);
        }
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmitEmpresa = async () => {
    try {
      setLoading(true);
      // Montar FormData para enviar arquivo e campos de texto
      const formData = new FormData();
      formData.append('nome', nomeEmpresa || '');
      formData.append('corPrimaria', corPrimaria || '');
      formData.append('corSecundaria', corSecundaria || '');
      formData.append('ativo', String(ativoEmpresa));
      formData.append('limiteInstancias', limiteInstancias);
      formData.append('limiteUsuarios', limiteUsuarios);
      if (empresaFile) {
        formData.append('file', empresaFile);
      } else if (previewImage && previewImage.startsWith('/uploads/')) {
        // Caso já tenha uma URL existente (situações específicas), manter no backend
        formData.append('logoUrl', previewImage);
      }

      const res = await api.post('/empresas', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      const novaEmpresaId = res?.data?.data?.id;
      if (novaEmpresaId) {
        await api.put(`/configuracao-backup/empresa/${novaEmpresaId}`, montarPayloadBackupConfig());
      }
      await loadData();
      toast({
        title: 'Sucesso',
        description: 'Empresa cadastrada com sucesso',
      });
      resetEmpresaForm();
      setShowEmpresaModal(false);
    } catch (e) {
      toast({
        title: 'Erro',
        description: extractError(e),
        variant: 'destructive',
      });
    } finally {
      setLoading(false);
    }
  };

  const handleSubmitUsuario = async () => {
    try {
      setLoading(true);
      const data = {
        nome: nome,
        empresaId: empresa,
        email: email,
        senha: senha,
        role: role,
        ativo: ativo,
        filasVinculadas: filasUsuario,
      };
      const res = await api.post('/usuarios/create', data);
      await loadData();
      toast({
        title: 'Sucesso',
        description: 'Usuário cadastrado com sucesso',
      });
      resetUsuarioForm();
      setShowUsuarioModal(false);
    } catch (e: any) {
      toast({
        title: 'Erro',
        description: extractError(e?.response?.data?.message),
        variant: 'destructive',
      });
    } finally {
      setLoading(false);
    }
  };

  const handleSubmitFila = async () => {
    try {
      setLoading(true);
      const data = {
        empresaId: user.role === 'Admin' ? user.empresaId : empresa,
        nome: nomeFila,
        indice: indiceFila !== '' ? Number(indiceFila) : null,
        status: statusFila,
      };

      if (filaIdEdit) {
        await api.put(`/filas/${filaIdEdit}`, { ...data, id: filaIdEdit });
      } else {
        await api.post('/filas', data);
      }

      await loadData();
      toast({
        title: 'Sucesso',
        description: filaIdEdit ? 'Fila atualizada com sucesso' : 'Fila cadastrada com sucesso',
      });
      resetFilaForm();
      setShowFilaModal(false);
    } catch (e: any) {
      toast({
        title: 'Erro',
        description: extractError(e?.response?.data?.message),
        variant: 'destructive',
      });
    } finally {
      setLoading(false);
    }
  };

  const handleEmpresaIsEdit = async (empresa: any) => {
    setShowEmpresaModal(true);
    if (empresa) {
      setEmpresaIdEdit(empresa.id);
      setNomeEmpresa(empresa.nome);
      setPreviewImage(empresa.logoUrl ? `${API_BASE_URL}${empresa.logoUrl.startsWith('/') ? '' : '/'}${empresa.logoUrl}` : '');
      setCorPrimaria(empresa.corPrimaria);
      setCorSecundaria(empresa.corSecundaria);
      setAtivoEmpresa(empresa.ativo ?? true);
      setLimiteInstancias(empresa.limiteInstancias != null ? String(empresa.limiteInstancias) : '');
      setLimiteUsuarios(empresa.limiteUsuarios != null ? String(empresa.limiteUsuarios) : '');
      try {
        const { data } = await api.get(`/configuracao-backup/empresa/${empresa.id}`);
        const c = data.configuracao;
        setBackupConfig({
          ativo: !!c.ativo,
          frequencia: c.frequencia,
          diaSemana: c.diaSemana,
          diaMes: c.diaMes,
          horario: c.horario,
          backupMidias: !!c.backupMidias,
          midiasGrupos: !!c.midiasGrupos,
          destinoTipo: c.destinoTipo,
          diretorioLocal: c.diretorioLocal || '',
          remotoHost: c.remotoHost || '',
          remotoPorta: c.remotoPorta ?? 22,
          remotoUsuario: c.remotoUsuario || '',
          remotoAutenticacao: c.remotoAutenticacao || 'SENHA',
          remotoSenha: c.remotoSenha || '',
          remotoChavePrivada: c.remotoChavePrivada || '',
          remotoDiretorio: c.remotoDiretorio || '',
          ultimoBackupEm: c.ultimoBackupEm,
          ultimoBackupStatus: c.ultimoBackupStatus,
          ultimoBackupMensagem: c.ultimoBackupMensagem,
        });
      } catch (e) {
        toast({ title: 'Erro', description: extractError(e), variant: 'destructive' });
      }
    } else {
      setBackupConfig(defaultConfiguracaoBackup);
    }
  };

  const handleEditEmpresa = async (id: string) => {
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append('id', empresaIdEdit || id);
      formData.append('nome', nomeEmpresa || '');
      formData.append('corPrimaria', corPrimaria || '');
      formData.append('corSecundaria', corSecundaria || '');
      formData.append('ativo', String(ativoEmpresa));
      formData.append('limiteInstancias', limiteInstancias);
      formData.append('limiteUsuarios', limiteUsuarios);
      if (empresaFile) {
        formData.append('file', empresaFile);
      } else if (previewImage && previewImage.startsWith('/uploads/')) {
        formData.append('logoUrl', previewImage);
      }

      await api.put(`/empresas/${id}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      await api.put(`/configuracao-backup/empresa/${id}`, montarPayloadBackupConfig());
      await loadData();
      toast({
        title: 'Sucesso',
        description: 'Empresa editada com sucesso',
      });
      resetEmpresaForm();
      setShowEmpresaModal(false);
    } catch (e: any) {
      toast({
        title: 'Erro',
        description: extractError(e?.response?.data?.message),
        variant: 'destructive',
      });
    } finally {
      setLoading(false);
    }
  };

  const handleTestarConexaoBackup = async () => {
    if (!empresaIdEdit) return;
    try {
      setTestandoConexaoBackup(true);
      await api.post(`/configuracao-backup/empresa/${empresaIdEdit}/testar-conexao`);
      toast({ title: 'Sucesso', description: 'Conexão SSH estabelecida com sucesso.' });
    } catch (e) {
      toast({ title: 'Erro', description: extractError(e), variant: 'destructive' });
    } finally {
      setTestandoConexaoBackup(false);
    }
  };

  const handleExecutarBackupAgora = async () => {
    if (!empresaIdEdit) return;
    try {
      setExecutandoBackupAgora(true);
      const { data } = await api.post(`/configuracao-backup/empresa/${empresaIdEdit}/executar`);
      const c = data.configuracao;
      setBackupConfig((prev) => ({
        ...prev,
        ultimoBackupEm: c.ultimoBackupEm,
        ultimoBackupStatus: c.ultimoBackupStatus,
        ultimoBackupMensagem: c.ultimoBackupMensagem,
      }));
      toast({
        title: c.ultimoBackupStatus === 'ERRO' ? 'Erro' : 'Sucesso',
        description: data.message,
        variant: c.ultimoBackupStatus === 'ERRO' ? 'destructive' : 'default',
      });
    } catch (e) {
      toast({ title: 'Erro', description: extractError(e), variant: 'destructive' });
    } finally {
      setExecutandoBackupAgora(false);
    }
  };

  const handleDeleteEmpresa = async (id: string) => {
    try {
      setLoading(true);
      const res = await api.delete(`/empresas/${id}`);
      await loadData();
      toast({
        title: 'Sucesso',
        description: 'Empresa excluída com sucesso',
      });
      resetEmpresaForm();
      setShowEmpresaModal(false);
    } catch (e: any) {
      const dados = e?.response?.data;
      if (e?.response?.status === 409 && dados?.codigo === 'EMPRESA_COM_REGISTROS') {
        setExclusaoCompleta({ empresa: dados.empresa, vinculos: dados.vinculos });
        return;
      }
      toast({
        title: 'Erro',
        description: extractError(dados?.message),
        variant: 'destructive',
      });
    } finally {
      setLoading(false);
    }
  };

  const handleEmpresaExcluidaCompleta = async () => {
    setExclusaoCompleta(null);
    resetEmpresaForm();
    setShowEmpresaModal(false);
    await loadData();
  };

  const handleUsuarioIsEdit = (usuario: any) => {
    setShowUsuarioModal(true);
    if (usuario) {
      setEmpresaIdEdit(usuario.empresaId);
      setUsuarioIdEdit(usuario.id);
      setNome(usuario.nome);
      setEmail(usuario.email);
      // Don't set senha - passwords are not returned from backend for security
      // Leave it empty so user can optionally change it
      setSenha('');
      setRole(usuario.role);
      setAtivo(usuario.ativo);
      setAcessoConfidencialTotal(!!usuario.acessoConfidencialTotal);
      setAcessoConfidencialOriginal(!!usuario.acessoConfidencialTotal);
      setFilasUsuario(Array.isArray(usuario.filas) ? usuario.filas.map((f: any) => f.id) : []);
      setEmpresa(usuario.empresaId || '');
    } else {
      // Pré-seleciona e trava empresa para Admin
      if (user?.role === 'Admin') {
        setEmpresa(user?.empresaId || '');
      }
    }
  };

  const handleEditUsuario = async (id: string) => {
    try {
      setLoading(true);
      const data = {
        id: usuarioIdEdit,
        empresaId: empresa,
        nome: nome,
        email: email,
        senha: senha,
        role: role,
        ativo: ativo,
        filas: filasUsuario,
      };
      const res = await api.put(`/usuarios/${id}`, data);
      // Acesso confidencial total: endpoint próprio, só SuperAdmin
      const novoAcessoConfidencial = role === 'Admin' && acessoConfidencialTotal;
      if (user?.role === 'SuperAdmin' && novoAcessoConfidencial !== acessoConfidencialOriginal) {
        await api.patch(`/usuarios/${id}/acesso-confidencial`, { acessoConfidencialTotal: novoAcessoConfidencial });
      }
      await loadData();
      toast({
        title: 'Sucesso',
        description: 'Usuário editado com sucesso',
      });
      resetUsuarioForm();
      setShowUsuarioModal(false);
    } catch (e: any) {
      toast({
        title: 'Erro',
        description: extractError(e?.response?.data?.message),
        variant: 'destructive',
      });
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteUsuario = async (id: string) => {
    try {
      setLoading(true);
      const res = await api.delete(`/usuarios/${id}`);
      await loadData();
      toast({
        title: 'Sucesso',
        description: 'Usuário excluído com sucesso',
      });
      resetUsuarioForm();
      setShowUsuarioModal(false);
    } catch (e: any) {
      toast({
        title: 'Erro',
        description: extractError(e?.response?.data?.message),
        variant: 'destructive',
      });
    } finally {
      setLoading(false);
    }
  };

  const handleFilaIsEdit = (fila: any) => {
    setShowFilaModal(true);
    if (fila) {
      setEmpresaIdEdit(fila.empresaId);
      setFilaIdEdit(fila.id);
      setNomeFila(fila.nome);
      setIndiceFila(fila.indice ?? '');
      setStatusFila(fila.status === 'ativa');
      if (user.role === 'SuperAdmin') {
        setEmpresa(fila.empresaId);
      }
    } else if (user.role === 'Admin') {
      setEmpresa(user.empresaId);
    }
  };

  const handleDeleteFila = async (id: string) => {
    try {
      setLoading(true);
      await api.delete(`/filas/${id}`);
      await loadData();
      toast({
        title: 'Sucesso',
        description: 'Fila excluída com sucesso',
      });
      resetFilaForm();
      setShowFilaModal(false);
    } catch (e: any) {
      toast({
        title: 'Erro',
        description: extractError(e?.response?.data?.message),
        variant: 'destructive',
      });
    } finally {
      setLoading(false);
    }
  };

  const handleOpenModalConfirm = (tipo: string, id: string) => {
    setShowCancelModal(true);
    setTipoModalConfirmacao(tipo);
    setIdModalConfirmacao(id);
  };

  const handleDeleteModalConfirm = () => {
    switch (tipoModalConfirmacao) {
      case 'empresa':
        handleDeleteEmpresa(idModalConfirmacao);
        break;
      case 'fila':
        handleDeleteFila(idModalConfirmacao);
        break;
      case 'usuario':
        handleDeleteUsuario(idModalConfirmacao);
        break;
      case 'contato':
        handleDeleteContato(idModalConfirmacao);
        break;
      case 'tag':
        handleDeleteTag(idModalConfirmacao);
        break;
      case 'mensagemRapida':
        handleDeleteMensagemRapida(idModalConfirmacao);
        break;
      case 'categoria':
        handleDeleteCategoria(idModalConfirmacao);
        break;
    }
    setShowCancelModal(false);
  };

  const renderGeneralConfig = (category: CategoryItem) => {
    if (category.id === 'tenants') {
      return (
        <Card className="mb-6 p-4 dark:bg-slate-800">
          <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 mb-4">
            <h3 className="text-lg font-medium text-gray-500 dark:text-white">Empresas</h3>
            {user.role === 'SuperAdmin' && (
              <Button onClick={() => handleEmpresaIsEdit(null)} variant="outline" color="primary" className="dark:text-white dark:bg-slate-700">
                <Plus className="h-4 w-4 mr-2" />
                Cadastrar Empresa
              </Button>
            )}
          </div>
          <EmpresasTable
            empresas={empresas}
            loading={loading}
            total={empresasTotal}
            page={empresasPage}
            rowsPerPage={empresasRowsPerPage}
            onPageChange={setEmpresasPage}
            onRowsPerPageChange={(n) => { setEmpresasRowsPerPage(n); setEmpresasPage(0); }}
            onSort={(field, order) => { setEmpresasSort({ field, order }); setEmpresasPage(0); }}
            onSearch={(term) => { setEmpresasSearch(term); setEmpresasPage(0); }}
            onRowClick={() => { }}
            onEdit={handleEmpresaIsEdit}
            onDelete={(empresa) => handleOpenModalConfirm('empresa', empresa.id)}
            canEdit={user.role === 'SuperAdmin'}
          />
          {/* Modal de Empresa */}
          {showEmpresaModal && (
            <Dialog open={showEmpresaModal} onOpenChange={(open) => { setShowEmpresaModal(open); if (!open) resetEmpresaForm(); }}>
              <DialogContent className="dark:bg-slate-700">
                <h4 className="mb-4 font-bold text-lg text-gray-500 dark:text-white">Cadastro/Edição de Empresa</h4>
                {/* Formulário de empresa aqui */}
                <div className="grid grid-cols-1 sm:grid-cols-5 gap-4 my-4">
                  <div className="flex items-center justify-center sm:col-span-2">
                    <div className="relative">
                      <img src={previewImage ? previewImage : ''} className="w-[150px] h-[150px] rounded-lg border border-gray-200 bg-gray-100 cursor-pointer dark:border-slate-700 dark:bg-slate-700" />
                      <input type="file" accept="image/*" className="absolute inset-0 opacity-0 cursor-pointer" onChange={handleImageChange} />
                    </div>
                  </div>
                  <div className="flex flex-col gap-4 sm:col-span-3">
                    <div className="grid grid-cols-1 sm:grid-cols-4 items-start sm:items-center gap-1.5 sm:gap-4">
                      <Label htmlFor="nome" className="dark:text-white dark:bg-slate-700">Nome</Label>
                      <Input
                        name="nome"
                        value={nomeEmpresa}
                        onChange={(e) => setNomeEmpresa(e.target.value)}
                        placeholder="Nome da empresa"
                        className="sm:col-span-3 dark:text-white dark:bg-slate-700"
                      />
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-4 items-start sm:items-center gap-1.5 sm:gap-4">
                      <Label htmlFor="corPrimaria" className="dark:text-white dark:bg-slate-700">Cor Primária</Label>
                      <Input
                        name="corPrimaria"
                        value={corPrimaria}
                        type="color"
                        onChange={(e) => setCorPrimaria(e.target.value)}
                        placeholder="Digite a cor primária"
                        className="col-span-1 dark:text-white dark:bg-slate-700"
                      />
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-4 items-start sm:items-center gap-1.5 sm:gap-4">
                      <Label htmlFor="corSecundaria" className="dark:text-white dark:bg-slate-700">Cor Secundária</Label>
                      <Input
                        name="corSecundaria"
                        value={corSecundaria}
                        type="color"
                        onChange={(e) => setCorSecundaria(e.target.value)}
                        placeholder="Digite a cor secundária"
                        className="col-span-1 dark:text-white dark:bg-slate-700"
                      />
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-4 items-start sm:items-center gap-1.5 sm:gap-4">
                      <Label htmlFor="ativoEmpresa" className="dark:text-white">Ativo</Label>
                      <Switch
                        id="ativoEmpresa"
                        checked={ativoEmpresa}
                        onCheckedChange={setAtivoEmpresa}
                        className="sm:col-span-3"
                      />
                    </div>
                  </div>

                  <div className="sm:col-span-5 border-t border-gray-200 dark:border-slate-600 pt-4 mt-2">
                    <h5 className="font-semibold text-gray-600 dark:text-white mb-1">Limites</h5>
                    <p className="text-xs text-gray-500 dark:text-gray-300 mb-3">Deixe em branco para não limitar.</p>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                      <div className="flex flex-col gap-1">
                        <Label htmlFor="limiteInstancias" className="dark:text-white">Máx. de instâncias</Label>
                        <Input
                          id="limiteInstancias"
                          type="number"
                          min={0}
                          step={1}
                          value={limiteInstancias}
                          onChange={(e) => setLimiteInstancias(e.target.value.replace(/\D/g, ''))}
                          placeholder="Ilimitado"
                          className="dark:text-white dark:bg-slate-700"
                        />
                      </div>
                      <div className="flex flex-col gap-1">
                        <Label htmlFor="limiteUsuarios" className="dark:text-white">Máx. de usuários</Label>
                        <Input
                          id="limiteUsuarios"
                          type="number"
                          min={0}
                          step={1}
                          value={limiteUsuarios}
                          onChange={(e) => setLimiteUsuarios(e.target.value.replace(/\D/g, ''))}
                          placeholder="Ilimitado"
                          className="dark:text-white dark:bg-slate-700"
                        />
                      </div>
                    </div>
                  </div>

                  <ConfiguracaoBackupEmpresa
                    value={backupConfig}
                    onChange={(patch) => setBackupConfig((prev) => ({ ...prev, ...patch }))}
                    isEdicao={!!empresaIdEdit}
                    testandoConexao={testandoConexaoBackup}
                    executandoAgora={executandoBackupAgora}
                    onTestarConexao={handleTestarConexaoBackup}
                    onExecutarAgora={handleExecutarBackupAgora}
                  />
                </div>
                <div className="flex flex-wrap items-center justify-end gap-2 sm:gap-4">
                  <Button onClick={() => { resetEmpresaForm(); setShowEmpresaModal(false); }} variant="outline" color="primary" className="dark:text-white dark:bg-slate-700">Fechar</Button>
                  {empresaIdEdit ? (
                    <Button onClick={() => handleEditEmpresa(empresaIdEdit)} variant="secondary" color="green" className="dark:text-white dark:bg-slate-700">Salvar</Button>
                  ) : (
                    <Button onClick={() => handleSubmitEmpresa()} variant="secondary" color="green" className="dark:text-white dark:bg-slate-700">Salvar</Button>
                  )}
                </div>
              </DialogContent>
            </Dialog>
          )}
        </Card>
      );
    }
    if (category.id === 'users') {
      let roles = [
        { valor: 'User', nome: 'Usuário' },
        { valor: 'Admin', nome: 'Administrador' }
      ];

      if (user.role === 'SuperAdmin') {
        roles.unshift({ valor: 'SuperAdmin', nome: 'Super Admin' });
      }

      const usuariosFiltrados = usuarios.filter(u => u.role !== 'SuperAdmin').map(u => ({
        ...u,
        empresaNome: u.empresa?.nome,
        ativo: u.ativo !== undefined ? u.ativo : true,
        dataCriacao: u.dataCriacao || u.createdAt,
        dataAtualizacao: u.dataAtualizacao || u.updatedAt
      }));

      return (
        <Card className="mb-6 p-4 dark:bg-slate-800">
          <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 mb-4">
            <h3 className="text-lg font-medium text-gray-500 dark:text-white">Usuários</h3>
            {(user.role === 'Admin' || user.role === 'SuperAdmin') && (
              <Button onClick={() => handleUsuarioIsEdit(null)} variant="outline" color="primary" className="dark:text-white dark:bg-slate-700">
                <Plus className="h-4 w-4 mr-2" />
                Vincular/Cadastrar Usuário
              </Button>
            )}
          </div>
          {user.role === 'SuperAdmin' && (
            <div className="mb-4 max-w-xs">
              <Select
                value={usuariosEmpresaFiltro}
                onValueChange={(value) => { setUsuariosEmpresaFiltro(value); setUsuariosPage(0); }}
              >
                <SelectTrigger className="dark:bg-slate-700 dark:text-white">
                  <SelectValue placeholder="Filtrar por empresa" />
                </SelectTrigger>
                <SelectContent className="dark:bg-slate-700 dark:text-white">
                  <SelectItem value="todas">Todas as empresas</SelectItem>
                  {empresasFiltroUsuarios.map((emp: any) => (
                    <SelectItem key={emp.id} value={emp.id}>
                      {emp.nome}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
          )}
          <UsuariosTable
            usuarios={usuariosFiltrados}
            loading={loading}
            total={usuariosTotal}
            page={usuariosPage}
            rowsPerPage={usuariosRowsPerPage}
            onPageChange={setUsuariosPage}
            onRowsPerPageChange={(n) => { setUsuariosRowsPerPage(n); setUsuariosPage(0); }}
            onSort={(field, order) => { setUsuariosSort({ field, order }); setUsuariosPage(0); }}
            onSearch={(term) => { setUsuariosSearch(term); setUsuariosPage(0); }}
            onRowClick={() => { }}
            onEdit={handleUsuarioIsEdit}
            onDelete={(usuario) => handleOpenModalConfirm('usuario', usuario.id)}
            canEdit={user.role === 'Admin' || user.role === 'SuperAdmin'}
            showEmpresaColumn={user.role === 'SuperAdmin'}
          />
          {/* Modal de Usuário */}
          {showUsuarioModal && (
            <Dialog open={showUsuarioModal} onOpenChange={(open) => { setShowUsuarioModal(open); if (!open) resetUsuarioForm(); }}>
              <DialogContent className="dark:bg-slate-700">
                <h4 className="mb-4 font-bold text-lg text-gray-500 dark:text-white">Cadastro/Vinculação de Usuário</h4>
                {/* Formulário de usuário aqui */}
                {user.role === 'SuperAdmin' && (
                  <div className="grid grid-cols-1 sm:grid-cols-4 items-start sm:items-center gap-1.5 sm:gap-4 mb-2">
                    <Label htmlFor="empresa" className="dark:text-white dark:bg-slate-700">Empresa</Label>
                    <Select
                      name="empresa"
                      value={empresa}
                      onValueChange={(value) => { if (value !== empresa) setFilasUsuario([]); setEmpresa(value); }}
                    >
                      <SelectTrigger className="sm:col-span-3 dark:bg-slate-700 dark:text-white">
                        <SelectValue placeholder="Selecione uma empresa" />
                      </SelectTrigger>
                      <SelectContent className="dark:bg-slate-700 dark:text-white">
                        {empresasFiltroUsuarios.map((emp: any) => (
                          <SelectItem key={emp.id} value={emp.id}>
                            {emp.nome}
                          </SelectItem>
                        ))}
                      </SelectContent>
                    </Select>
                  </div>
                )}
                <div className="grid grid-cols-1 sm:grid-cols-4 items-start sm:items-center gap-1.5 sm:gap-4 mb-2">
                  <Label htmlFor="role" className="dark:text-white dark:bg-slate-700">Perfil</Label>
                  <Select
                    value={role}
                    onValueChange={(value) => setRole(value)}
                    name="role"
                    disabled={user.role === 'SuperAdmin' && !empresa}
                  >
                    <SelectTrigger className="sm:col-span-3 dark:bg-slate-700 dark:text-white">
                      <SelectValue placeholder="Selecione um perfil" />
                    </SelectTrigger>
                    <SelectContent className="dark:bg-slate-700 dark:text-white">
                      {roles.map((role) => (
                        <SelectItem key={role.valor} value={role.valor}>
                          <div className="flex items-center">
                            <div
                              className="w-4 h-4 rounded-full mr-2"
                            ></div>
                            {role.nome}
                          </div>
                        </SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-4 items-start sm:items-center gap-1.5 sm:gap-4 mb-2">
                  <Label className="dark:text-gray-200">
                    Filas
                  </Label>
                  <div className="sm:col-span-3">
                    <SelectWithSearch
                      options={filasEmpresa.map(fila => ({
                        value: fila.id,
                        label: fila.nome
                      }))}
                      value={filasUsuario}
                      onChange={setFilasUsuario}
                      placeholder={user.role === 'SuperAdmin' && !empresa ? 'Selecione a empresa primeiro' : 'Selecione as filas...'}
                      disabled={user.role === 'SuperAdmin' && !empresa}
                      emptyMessage="Nenhuma fila encontrada"
                      className="sm:col-span-3"
                    />
                  </div>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-4 items-start sm:items-center gap-1.5 sm:gap-4 mb-2">
                  <Label htmlFor="nome" className="dark:text-white dark:bg-slate-700">Nome</Label>
                  <Input
                    name="nome"
                    value={nome}
                    onChange={(e) => setNome(e.target.value)}
                    placeholder="Digite o nome do usuário"
                    className="sm:col-span-3 dark:bg-slate-700 dark:text-white"
                  />
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-4 items-start sm:items-center gap-1.5 sm:gap-4 mb-2">
                  <Label htmlFor="email" className="dark:text-white dark:bg-slate-700">Email</Label>
                  <Input
                    name="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Digite o email do usuário"
                    className="sm:col-span-3 dark:bg-slate-700 dark:text-white"
                  />
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-4 items-start sm:items-center gap-1.5 sm:gap-4 mb-2">
                  <Label htmlFor="senha" className="dark:text-white dark:bg-slate-700">Senha</Label>
                  <div className="relative sm:col-span-3">
                    <Input
                      name="senha"
                      type={mostrarSenha ? "text" : "password"}
                      value={senha}
                      onChange={(e) => setSenha(e.target.value)}
                      placeholder={usuarioIdEdit ? "Deixe em branco para manter a senha atual" : "Digite a senha do usuário"}
                      className="dark:bg-slate-700 dark:text-white pr-10"
                    />
                    <button
                      type="button"
                      onClick={() => setMostrarSenha(!mostrarSenha)}
                      className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 dark:text-gray-300"
                      tabIndex={-1}
                    >
                      {mostrarSenha ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
                    </button>
                  </div>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-4 items-start sm:items-center gap-1.5 sm:gap-4 mb-2">
                  <Label htmlFor="ativo" className="dark:text-white dark:bg-slate-700">Ativo?</Label>
                  <Switch
                    id="ativo"
                    checked={ativo}
                    onCheckedChange={setAtivo}
                    disabled={false}
                  />
                </div>
                {user.role === 'SuperAdmin' && usuarioIdEdit && role === 'Admin' && (
                  <div className="grid grid-cols-1 sm:grid-cols-4 items-start sm:items-center gap-1.5 sm:gap-4 mb-2">
                    <Label htmlFor="acessoConfidencialTotal" className="dark:text-white dark:bg-slate-700">Acesso confidencial total</Label>
                    <div className="sm:col-span-3 flex items-start gap-3">
                      <Switch
                        id="acessoConfidencialTotal"
                        checked={acessoConfidencialTotal}
                        onCheckedChange={setAcessoConfidencialTotal}
                      />
                      <span className="text-xs text-muted-foreground dark:text-gray-300">
                        Vê as conversas de todas as instâncias confidenciais da empresa (ex.: diretor). Somente o SuperAdmin altera.
                      </span>
                    </div>
                  </div>
                )}
                <div className="flex justify-end items-center gap-2 mb-2">
                  <Button onClick={() => { resetUsuarioForm(); setShowUsuarioModal(false); }} variant="outline" color="primary" className="dark:text-white dark:bg-slate-700">Fechar</Button>
                  {usuarioIdEdit ? (
                    <Button onClick={() => handleEditUsuario(usuarioIdEdit)} variant="secondary" color="green" className="dark:text-white dark:bg-slate-700">Salvar</Button>
                  ) : (
                    <Button onClick={() => handleSubmitUsuario()} variant="secondary" color="green" className="dark:text-white dark:bg-slate-700">Salvar</Button>
                  )}
                </div>
              </DialogContent>
            </Dialog>
          )}
        </Card>
      );
    }
    if (category.id === 'queues') {
      const filasComEmpresa = filas.map(f => ({
        ...f,
        empresaNome: f.empresa?.nome,
        ativo: f.ativo !== undefined ? f.ativo : (f.status === 'ativa'),
        dataCriacao: f.dataCriacao || f.createdAt,
        dataAtualizacao: f.dataAtualizacao || f.updatedAt
      }));

      return (
        <Card className="mb-6 p-4 dark:bg-slate-800">
          <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 mb-4">
            <h3 className="text-lg font-medium text-gray-500 dark:text-white">Filas</h3>
            {(user.role === 'Admin' || user.role === 'SuperAdmin') && (
              <Button onClick={() => handleFilaIsEdit(null)} variant="outline" color="primary" className="dark:text-white dark:bg-slate-700">
                <Plus className="h-4 w-4 mr-2" />
                Vincular/Cadastrar Fila
              </Button>
            )}
          </div>
          <FilasTable
            filas={filasComEmpresa}
            loading={loading}
            total={filasTotal}
            page={filasPage}
            rowsPerPage={filasRowsPerPage}
            onPageChange={setFilasPage}
            onRowsPerPageChange={(n) => { setFilasRowsPerPage(n); setFilasPage(0); }}
            onSort={(field, order) => { setFilasSort({ field, order }); setFilasPage(0); }}
            onSearch={(term) => { setFilasSearch(term); setFilasPage(0); }}
            onRowClick={() => { }}
            onEdit={handleFilaIsEdit}
            onDelete={(fila) => handleOpenModalConfirm('fila', fila.id)}
            canEdit={user.role === 'Admin' || user.role === 'SuperAdmin'}
            showEmpresaColumn={user.role === 'SuperAdmin'}
          />
          {/* Modal de Fila */}
          {showFilaModal && (
            <Dialog open={showFilaModal} onOpenChange={setShowFilaModal}>
              <DialogContent className="sm:max-w-[425px] dark:bg-slate-700">
                <DialogHeader>
                  <DialogTitle className="dark:text-white">{filaIdEdit ? 'Editar Fila' : 'Nova Fila'}</DialogTitle>
                  <DialogDescription className="dark:text-white">
                    {filaIdEdit ? 'Atualize os dados da fila' : 'Preencha os dados para criar uma nova fila'}
                  </DialogDescription>
                </DialogHeader>
                <div className="grid gap-4 py-4">
                  {user.role === 'SuperAdmin' && (
                    <div className="grid grid-cols-1 sm:grid-cols-4 items-start sm:items-center gap-1.5 sm:gap-4">
                      <Label htmlFor="empresa" className="dark:text-white">
                        Empresa
                      </Label>
                      <Select
                        value={empresa}
                        onValueChange={setEmpresa}
                        disabled={!!filaIdEdit}
                      >
                        <SelectTrigger className="sm:col-span-3 dark:bg-slate-700 dark:text-white">
                          <SelectValue placeholder="Selecione a empresa" />
                        </SelectTrigger>
                        <SelectContent className="dark:bg-slate-700 dark:text-white">
                          {empresas.map((emp) => (
                            <SelectItem key={emp.id} value={emp.id}>
                              {emp.nome}
                            </SelectItem>
                          ))}
                        </SelectContent>
                      </Select>
                    </div>
                  )}
                  <div className="grid grid-cols-1 sm:grid-cols-4 items-start sm:items-center gap-1.5 sm:gap-4">
                    <Label htmlFor="nomeFila" className="dark:text-white">
                      Nome
                    </Label>
                    <Input
                      id="nomeFila"
                      value={nomeFila}
                      onChange={(e) => setNomeFila(e.target.value)}
                      className="sm:col-span-3 dark:bg-slate-700 dark:border-slate-600 dark:text-white"
                      placeholder="Nome da fila"
                    />
                  </div>
                  <div className="grid grid-cols-1 sm:grid-cols-4 items-start sm:items-center gap-1.5 sm:gap-4">
                    <Label htmlFor="indiceFila" className="dark:text-white">
                      Índice
                    </Label>
                    <Input
                      id="indiceFila"
                      type="number"
                      value={indiceFila}
                      onChange={(e) => setIndiceFila(e.target.value === '' ? '' : Number(e.target.value))}
                      className="sm:col-span-3 dark:bg-slate-700 dark:border-slate-600 dark:text-white"
                      placeholder="Ex: 1"
                    />
                  </div>
                  <div className="grid grid-cols-1 sm:grid-cols-4 items-start sm:items-center gap-1.5 sm:gap-4">
                    <Label htmlFor="statusFila" className="dark:text-white">
                      Ativo
                    </Label>
                    <Switch
                      id="statusFila"
                      checked={statusFila}
                      onCheckedChange={setStatusFila}
                      className="sm:col-span-3 dark:bg-slate-700 dark:text-white"
                    />
                  </div>
                </div>
                <DialogFooter>
                  <Button
                    type="button"
                    variant="outline"
                    className="dark:text-white dark:bg-slate-700"
                    onClick={() => {
                      resetFilaForm();
                      setShowFilaModal(false);
                    }}
                  >
                    Cancelar
                  </Button>
                  <Button
                    type="button"
                    onClick={handleSubmitFila}
                    disabled={!nomeFila || (user.role === 'SuperAdmin' && !empresa) || loading}
                  >
                    {loading ? 'Salvando...' : 'Salvar'}
                  </Button>
                </DialogFooter>
              </DialogContent>
            </Dialog>
          )}
        </Card>
      );
    }
  }

  const renderAppearanceConfig = (category: CategoryItem) => (
    <Card className="mb-6 p-4">
      <h3 className="text-lg font-medium mb-4">Aparência</h3>

      <div className="mb-4">
        <Label htmlFor="corPrimaria" className="dark:text-white dark:bg-slate-700">Cor Primária</Label>
        <Input
          id="corPrimaria"
          type="color"
          value={formValues.corPrimaria || '#000000'}
          onChange={(e) => handleChange('corPrimaria', e.target.value)}
          className="mt-1 p-1 h-10 w-20"
        />
      </div>

      <div className="mb-4">
        <Label htmlFor="corSecundaria" className="dark:text-white dark:bg-slate-700">Cor Secundária</Label>
        <Input
          id="corSecundaria"
          type="color"
          value={formValues.corSecundaria || '#000000'}
          onChange={(e) => handleChange('corSecundaria', e.target.value)}
          className="mt-1 p-1 h-10 w-20"
        />
      </div>
    </Card>
  );

  const renderBusinessHoursConfig = (category: CategoryItem) => {
    const isWeekday = (day: string): day is keyof typeof formValues.horarioAtendimento => {
      return ['segunda', 'terca', 'quarta', 'quinta', 'sexta', 'sabado', 'domingo'].includes(day);
    };

    return (
      <Card className="mb-6 p-4">
        <h3 className="text-lg font-medium mb-4">Horário de Atendimento</h3>
        {weekDays.map((day: WeekDay) => {
          if (isWeekday(day)) {
            const dayConfig = formValues.horarioAtendimento?.[day];
            const dayConfigSafe = dayConfig ?? { ativo: false, inicio: '', fim: '' };

            return (
              <Card key={day} className="mb-4 p-4">
                <h4 className="font-medium mb-2">{day}</h4>

                <div className="flex items-center mb-2">
                  <Switch
                    id={`${day}-ativo`}
                    checked={dayConfigSafe.ativo}
                    onCheckedChange={(checked) => handleNestedChange('horarioAtendimento', day, { ...dayConfigSafe, ativo: checked })}
                    className="mr-2"
                  />
                  <Label htmlFor={`${day}-ativo`}>Ativo</Label>
                </div>

                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <Label htmlFor={`${day}-inicio`}>Início</Label>
                    <Input
                      id={`${day}-inicio`}
                      type="time"
                      value={dayConfigSafe.inicio || ''}
                      onChange={(e) => handleNestedChange('horarioAtendimento', day, { ...dayConfigSafe, inicio: e.target.value })}
                      className="mt-1"
                    />
                  </div>
                  <div>
                    <Label htmlFor={`${day}-fim`}>Fim</Label>
                    <Input
                      id={`${day}-fim`}
                      type="time"
                      value={dayConfigSafe.fim || ''}
                      onChange={(e) => handleNestedChange('horarioAtendimento', day, { ...dayConfigSafe, fim: e.target.value })}
                      className="mt-1"
                    />
                  </div>
                </div>
              </Card>
            );
          }
          return null;
        })}
      </Card>
    );
  };

  const renderNotificationsConfig = (category: CategoryItem) => (
    <Card className="mb-6 p-4">
      <h3 className="text-lg font-medium mb-4">Notificações</h3>

      <div className="space-y-4">
        <div className="flex items-center">
          <Switch
            id="novoAtendimento"
            checked={formValues.notificacoes?.novoAtendimento || false}
            onCheckedChange={(checked) => handleNestedChange('notificacoes', 'novoAtendimento', checked)}
            className="mr-2"
          />
          <Label htmlFor="novoAtendimento">Novo Atendimento</Label>
        </div>

        <div className="flex items-center">
          <Switch
            id="mensagemRecebida"
            checked={formValues.notificacoes?.mensagemRecebida || false}
            onCheckedChange={(checked) => handleNestedChange('notificacoes', 'mensagemRecebida', checked)}
            className="mr-2"
          />
          <Label htmlFor="mensagemRecebida">Mensagem Recebida</Label>
        </div>

        <div className="flex items-center">
          <Switch
            id="atendimentoTransferido"
            checked={formValues.notificacoes?.atendimentoTransferido || false}
            onCheckedChange={(checked) => handleNestedChange('notificacoes', 'atendimentoTransferido', checked)}
            className="mr-2"
          />
          <Label htmlFor="atendimentoTransferido">Atendimento Transferido</Label>
        </div>

        <div className="flex items-center">
          <Switch
            id="atendimentoEncerrado"
            checked={formValues.notificacoes?.atendimentoEncerrado || false}
            onCheckedChange={(checked) => handleNestedChange('notificacoes', 'atendimentoEncerrado', checked)}
            className="mr-2"
          />
          <Label htmlFor="atendimentoEncerrado">Atendimento Encerrado</Label>
        </div>

        <div className="flex items-center">
          <Switch
            id="email"
            checked={formValues.notificacoes?.email || false}
            onCheckedChange={(checked) => handleNestedChange('notificacoes', 'email', checked)}
            className="mr-2"
          />
          <Label htmlFor="email">Notificação por E-mail</Label>
        </div>

        <div className="flex items-center">
          <Switch
            id="som"
            checked={formValues.notificacoes?.som || false}
            onCheckedChange={(checked) => handleNestedChange('notificacoes', 'som', checked)}
            className="mr-2"
          />
          <Label htmlFor="som">Som de Notificação</Label>
        </div>
      </div>
    </Card>
  );

  const renderIntegrationsConfig = (category: CategoryItem) => (
    <Card className="mb-6 p-4 dark:bg-gray-800">
      <h3 className="text-lg font-medium mb-4 dark:text-gray-200">Integrações</h3>
      <div className="mb-4">
        <EvolutionApiConnection />
      </div>
    </Card>
  );

  // Appearance subcategories
  const renderThemeConfig = () => (
    <Card className="mb-6 p-4 dark:bg-slate-800">
      <h3 className="text-lg font-medium mb-4 text-gray-500 dark:text-white">Tema</h3>
      <div className="space-y-4">
        <div>
          <Label className="dark:text-white">Modo de Visualização</Label>
          <p className="text-sm text-gray-500 dark:text-gray-400 mb-2">Escolha entre modo claro ou escuro</p>
          <Select defaultValue="system">
            <SelectTrigger className="w-full dark:bg-slate-700 dark:text-white">
              <SelectValue placeholder="Selecione o tema" />
            </SelectTrigger>
            <SelectContent className="dark:bg-slate-700 dark:text-white">
              <SelectItem value="light">Claro</SelectItem>
              <SelectItem value="dark">Escuro</SelectItem>
              <SelectItem value="system">Sistema</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>
    </Card>
  );

  const renderColorsConfig = () => (
    <Card className="mb-6 p-4 dark:bg-slate-800">
      <h3 className="text-lg font-medium mb-4 text-gray-500 dark:text-white">Cores</h3>
      <div className="space-y-4">
        <div className="grid grid-cols-2 gap-4">
          <div>
            <Label htmlFor="corPrimaria" className="dark:text-white">Cor Primária</Label>
            <div className="flex gap-2 items-center mt-1">
              <Input
                id="corPrimaria"
                type="color"
                value={corPrimaria}
                onChange={(e) => setCorPrimaria(e.target.value)}
                className="w-20 h-10 p-1 dark:bg-slate-700"
              />
              <Input
                type="text"
                value={corPrimaria}
                onChange={(e) => setCorPrimaria(e.target.value)}
                className="flex-1 dark:bg-slate-700 dark:text-white"
                placeholder="#000000"
              />
            </div>
          </div>
          <div>
            <Label htmlFor="corSecundaria" className="dark:text-white">Cor Secundária</Label>
            <div className="flex gap-2 items-center mt-1">
              <Input
                id="corSecundaria"
                type="color"
                value={corSecundaria}
                onChange={(e) => setCorSecundaria(e.target.value)}
                className="w-20 h-10 p-1 dark:bg-slate-700"
              />
              <Input
                type="text"
                value={corSecundaria}
                onChange={(e) => setCorSecundaria(e.target.value)}
                className="flex-1 dark:bg-slate-700 dark:text-white"
                placeholder="#FFFFFF"
              />
            </div>
          </div>
        </div>
        <Button className="dark:bg-slate-700 dark:text-white">Salvar Cores</Button>
      </div>
    </Card>
  );

  const renderLogoConfig = () => (
    <Card className="mb-6 p-4 dark:bg-slate-800">
      <h3 className="text-lg font-medium mb-4 text-gray-500 dark:text-white">Logo</h3>
      <div className="space-y-4">
        <div className="flex flex-col items-center gap-4">
          <div className="relative w-48 h-48 border-2 border-dashed border-gray-300 dark:border-gray-600 rounded-lg flex items-center justify-center bg-gray-50 dark:bg-slate-700">
            {previewImage ? (
              <img src={previewImage} alt="Logo" className="max-w-full max-h-full object-contain" />
            ) : (
              <div className="text-center">
                <Upload className="mx-auto h-12 w-12 text-gray-400" />
                <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">Clique para fazer upload</p>
              </div>
            )}
            <input
              type="file"
              accept="image/*"
              className="absolute inset-0 opacity-0 cursor-pointer"
              onChange={handleImageChange}
            />
          </div>
          <div className="text-sm text-gray-500 dark:text-gray-400">
            Formatos aceitos: PNG, JPG, SVG (max 2MB)
          </div>
        </div>
        <Button className="w-full dark:bg-slate-700 dark:text-white">Salvar Logo</Button>
      </div>
    </Card>
  );

  const renderBusinessDaysConfig = () => (
    <Card className="mb-6 p-4 dark:bg-slate-800">
      <h3 className="text-lg font-medium mb-4 text-gray-500 dark:text-white">Dias de Atendimento</h3>
      <div className="space-y-3">
        {weekDays.map((day) => (
          <div key={day} className="flex items-center justify-between p-3 border border-gray-200 dark:border-gray-700 rounded-lg gap-3">
            <Label htmlFor={`day-${day}`} className="capitalize dark:text-white">
              {day === 'segunda' ? 'Segunda-feira' :
                day === 'terca' ? 'Terça-feira' :
                  day === 'quarta' ? 'Quarta-feira' :
                    day === 'quinta' ? 'Quinta-feira' :
                      day === 'sexta' ? 'Sexta-feira' :
                        day === 'sabado' ? 'Sábado' : 'Domingo'}
            </Label>
            <Switch
              id={`day-${day}`}
              checked={formValues.horarioAtendimento?.[day]?.ativo || false}
              onCheckedChange={(checked) => handleNestedChange('horarioAtendimento', day, {
                ...(formValues.horarioAtendimento?.[day] || { inicio: '', fim: '' }),
                ativo: checked
              })}
            />
          </div>
        ))}
      </div>
      <Button className="w-full mt-4 dark:bg-slate-700 dark:text-white">Salvar Dias</Button>
    </Card>
  );

  const renderBusinessHoursTimeConfig = () => (
    <Card className="mb-6 p-4 dark:bg-slate-800">
      <h3 className="text-lg font-medium mb-4 text-gray-500 dark:text-white">Horários de Atendimento</h3>
      <div className="space-y-4">
        {weekDays.map((day) => {
          const dayConfig = formValues.horarioAtendimento?.[day];
          const dayConfigSafe = dayConfig ?? { ativo: false, inicio: '', fim: '' };

          return (
            <div key={day} className="p-4 border border-gray-200 dark:border-gray-700 rounded-lg">
              <div className="flex items-center justify-between mb-3">
                <h4 className="font-medium capitalize dark:text-white">
                  {day === 'segunda' ? 'Segunda-feira' :
                    day === 'terca' ? 'Terça-feira' :
                      day === 'quarta' ? 'Quarta-feira' :
                        day === 'quinta' ? 'Quinta-feira' :
                          day === 'sexta' ? 'Sexta-feira' :
                            day === 'sabado' ? 'Sábado' : 'Domingo'}
                </h4>
                <Switch
                  checked={dayConfigSafe.ativo}
                  onCheckedChange={(checked) => handleNestedChange('horarioAtendimento', day, {
                    ...dayConfigSafe,
                    ativo: checked
                  })}
                />
              </div>
              {dayConfigSafe.ativo && (
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <Label htmlFor={`${day}-inicio`} className="dark:text-white">Início</Label>
                    <Input
                      id={`${day}-inicio`}
                      type="time"
                      value={dayConfigSafe.inicio || ''}
                      onChange={(e) => handleNestedChange('horarioAtendimento', day, {
                        ...dayConfigSafe,
                        inicio: e.target.value
                      })}
                      className="mt-1 dark:bg-slate-700 dark:text-white"
                    />
                  </div>
                  <div>
                    <Label htmlFor={`${day}-fim`} className="dark:text-white">Fim</Label>
                    <Input
                      id={`${day}-fim`}
                      type="time"
                      value={dayConfigSafe.fim || ''}
                      onChange={(e) => handleNestedChange('horarioAtendimento', day, {
                        ...dayConfigSafe,
                        fim: e.target.value
                      })}
                      className="mt-1 dark:bg-slate-700 dark:text-white"
                    />
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>
      <Button className="w-full mt-4 dark:bg-slate-700 dark:text-white">Salvar Horários</Button>
    </Card>
  );

  const renderFilesConfig = () => (
    <Card className="mb-6 p-4 dark:bg-slate-800">
      <h3 className="text-lg font-medium mb-4 text-gray-500 dark:text-white">Configurações de Arquivos</h3>
      <div className="space-y-4">
        <div>
          <Label htmlFor="maxFileSize" className="dark:text-white">Tamanho Máximo de Arquivo (MB)</Label>
          <Input
            id="maxFileSize"
            type="number"
            defaultValue="10"
            className="mt-1 dark:bg-slate-700 dark:text-white"
            placeholder="10"
          />
        </div>
        <div>
          <Label className="dark:text-white">Tipos de Arquivo Permitidos</Label>
          <div className="mt-2 space-y-2">
            {['Imagens (PNG, JPG, GIF)', 'Documentos (PDF, DOC, DOCX)', 'Planilhas (XLS, XLSX, CSV)', 'Vídeos (MP4, AVI)', 'Áudios (MP3, WAV)'].map((tipo) => (
              <div key={tipo} className="flex items-center">
                <Switch id={tipo} defaultChecked />
                <Label htmlFor={tipo} className="ml-2 dark:text-white">{tipo}</Label>
              </div>
            ))}
          </div>
        </div>
        <Button className="w-full dark:bg-slate-700 dark:text-white">Salvar Configurações</Button>
      </div>
    </Card>
  );

  const renderChatConfigurationsConfig = () => (
    <Card className="mb-6 p-4 dark:bg-slate-800">
      <h3 className="text-lg font-medium mb-4 text-gray-500 dark:text-white">Configurações do Chat</h3>
      <Tabs defaultValue="geral" className="space-y-4">
        <TabsList className="grid grid-cols-3 w-full bg-gray-200 dark:bg-slate-900 dark:border dark:border-slate-700">
          <TabsTrigger value="geral" className="dark:text-gray-300 dark:data-[state=active]:bg-slate-600 dark:data-[state=active]:text-white">Geral</TabsTrigger>
          <TabsTrigger value="privado" className="dark:text-gray-300 dark:data-[state=active]:bg-slate-600 dark:data-[state=active]:text-white">Privado</TabsTrigger>
          <TabsTrigger value="grupos" className="dark:text-gray-300 dark:data-[state=active]:bg-slate-600 dark:data-[state=active]:text-white">Grupos</TabsTrigger>
        </TabsList>

        <TabsContent value="geral" className="space-y-3 mt-0">
          <p className="text-sm text-gray-500 dark:text-gray-400">Valem para todos os atendimentos.</p>
          <div className="flex items-center justify-between p-3 border border-gray-200 dark:border-gray-700 rounded-lg gap-3">
            <div className="flex-1">
              <Label className="dark:text-white font-medium">Assinatura do Atendente</Label>
              <p className="text-sm text-gray-500 dark:text-gray-400">Adicionar assinatura ao final das mensagens e captions</p>
            </div>
            <Switch
              checked={assinaturaAtendente}
              onCheckedChange={setAssinaturaAtendente}
            />
          </div>

          {assinaturaAtendente && (
            <div className="ml-4 p-3 bg-gray-50 dark:bg-slate-700 rounded-lg">
              <Label htmlFor="textoAssinatura" className="dark:text-white">Texto da Assinatura</Label>
              <Input
                id="textoAssinatura"
                value={textoAssinatura}
                onChange={(e) => setTextoAssinatura(e.target.value)}
                className="mt-1 dark:bg-slate-600 dark:text-white"
                placeholder="Ex: {saudacao} - {nome_atendente} - {nome_contato}"
              />
              <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
                Variáveis disponíveis: {'{nome_atendente}'}, {'{empresa}'}, {'{saudacao}'}, {'{nome_contato}'}
              </p>
            </div>
          )}

          <div className="flex items-center justify-between p-3 border border-gray-200 dark:border-gray-700 rounded-lg gap-3">
            <div>
              <Label className="dark:text-white font-medium">Permitir Notas</Label>
              <p className="text-sm text-gray-500 dark:text-gray-400">Habilitar cadastro de notas nos atendimentos</p>
            </div>
            <Switch
              checked={permitirNotas}
              onCheckedChange={setPermitirNotas}
            />
          </div>

          <div className="flex items-center justify-between p-3 border border-gray-200 dark:border-gray-700 rounded-lg gap-3">
            <div>
              <Label className="dark:text-white font-medium">Permitir Tags</Label>
              <p className="text-sm text-gray-500 dark:text-gray-400">Habilitar uso de tags nos atendimentos</p>
            </div>
            <Switch
              checked={permitirTags}
              onCheckedChange={setPermitirTags}
            />
          </div>

          <div className="flex items-center justify-between p-3 border border-gray-200 dark:border-gray-700 rounded-lg gap-3">
            <div>
              <Label className="dark:text-white font-medium">Usuário Pode Finalizar Atendimento Na Aba Pendentes</Label>
              <p className="text-sm text-gray-500 dark:text-gray-400">Permitir que usuários possam finalizar atendimentos na aba Pendentes</p>
            </div>
            <Switch
              checked={usuarioPodeFinalizarTicket}
              onCheckedChange={setUsuarioPodeFinalizarTicket}
            />
          </div>

          <div className="flex items-center justify-between p-3 border border-gray-200 dark:border-gray-700 rounded-lg gap-3">
            <div>
              <Label className="dark:text-white font-medium">Usuário Pode Transferir Atendimento</Label>
              <p className="text-sm text-gray-500 dark:text-gray-400">Permitir que usuários com perfil User transfiram atendimentos</p>
            </div>
            <Switch
              checked={usuarioPodeTransferirTicket}
              onCheckedChange={setUsuarioPodeTransferirTicket}
            />
          </div>

          <div className="flex items-center justify-between p-3 border border-gray-200 dark:border-gray-700 rounded-lg gap-3">
            <div>
              <Label className="dark:text-white font-medium">Transferência Mostra Todo o Histórico</Label>
              <p className="text-sm text-gray-500 dark:text-gray-400">Quando ativo, quem recebe o atendimento vê toda a conversa. Quando desativado, quem transfere escolhe quais mensagens anteriores o outro atendente poderá ver; as demais ficam ocultas para ele (administradores sempre veem tudo)</p>
            </div>
            <Switch
              checked={transferenciaHistoricoCompleto}
              onCheckedChange={setTransferenciaHistoricoCompleto}
            />
          </div>

          <div className="flex items-center justify-between gap-4 p-3 border border-gray-200 dark:border-gray-700 rounded-lg">
            <div>
              <Label className="dark:text-white font-medium">Instância na Transferência</Label>
              <p className="text-sm text-gray-500 dark:text-gray-400">O que fazer quando o atendente que recebe tem instância vinculada. A troca só acontece entre instâncias Evolution e Uazapi conectadas; conversas da API oficial (Meta) e de grupos ficam na instância de origem</p>
            </div>
            <Select
              value={transferenciaInstanciaModo}
              onValueChange={(v) => setTransferenciaInstanciaModo(v as 'MANTER' | 'PERGUNTAR' | 'TRANSFERIR')}
            >
              <SelectTrigger className="w-64 shrink-0 dark:bg-slate-700 dark:text-white">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="TRANSFERIR">Transferir para a instância do recebedor</SelectItem>
                <SelectItem value="PERGUNTAR">Perguntar a quem transfere</SelectItem>
                <SelectItem value="MANTER">Manter na instância de origem</SelectItem>
              </SelectContent>
            </Select>
          </div>

          <div className="flex items-center justify-between p-3 border border-gray-200 dark:border-gray-700 rounded-lg gap-3">
            <div>
              <Label className="dark:text-white font-medium">Agrupar Chats por Contatos</Label>
              <p className="text-sm text-gray-500 dark:text-gray-400">Mostrar apenas um chat por contato no dashboard, baseado no mais recente</p>
            </div>
            <Switch
              checked={agruparChatsPorContatos}
              onCheckedChange={setAgruparChatsPorContatos}
            />
          </div>

          <div className="flex items-center justify-between p-3 border border-gray-200 dark:border-gray-700 rounded-lg gap-3">
            <div>
              <Label className="dark:text-white font-medium">Conversas Carregadas por Vez</Label>
              <p className="text-sm text-gray-500 dark:text-gray-400">Quantidade de conversas carregadas de cada vez na tela de atendimento (pendentes, abertas e fechadas). Mais conversas ao rolar a lista são carregadas automaticamente. Não afeta a pesquisa de conversas</p>
            </div>
            <Input
              type="number"
              min={10}
              max={200}
              value={tamanhoPaginaAtendimento}
              onChange={(e) => setTamanhoPaginaAtendimento(Math.min(200, Math.max(10, Number(e.target.value) || 50)))}
              className="w-24 shrink-0 dark:text-white dark:bg-slate-700"
            />
          </div>

          <div className="flex items-center justify-between p-3 border border-gray-200 dark:border-gray-700 rounded-lg gap-3">
            <div>
              <Label className="dark:text-white font-medium">Exibir Atendimentos Finalizados para Todos</Label>
              <p className="text-sm text-gray-500 dark:text-gray-400">Quando ativo, todos os atendentes podem visualizar os atendimentos finalizados, independente de quem realizou o atendimento</p>
            </div>
            <Switch
              checked={exibirFinalizadosParaTodos}
              onCheckedChange={setExibirFinalizadosParaTodos}
            />
          </div>

          <div className="flex items-center justify-between p-3 border border-gray-200 dark:border-gray-700 rounded-lg gap-3">
            <div>
              <Label className="dark:text-white font-medium">Somente Administradores Veem Atendimentos Pendentes</Label>
              <p className="text-sm text-gray-500 dark:text-gray-400">Quando ativo, apenas usuários com perfil Admin visualizam os atendimentos pendentes. Usuários comuns não veem os pendentes</p>
            </div>
            <Switch
              checked={apenasAdminVePendentes}
              onCheckedChange={setApenasAdminVePendentes}
            />
          </div>

          <div className="flex items-center justify-between p-3 border border-gray-200 dark:border-gray-700 rounded-lg">
            <div>
              <Label className="dark:text-white font-medium">Habilitar Kanban</Label>
              <p className="text-sm text-gray-500 dark:text-gray-400">Exibir visualização Kanban para gerenciar tickets por colunas</p>
            </div>
            <Switch
              checked={permitirKanban}
              onCheckedChange={setPermitirKanban}
            />
          </div>

          <div className="flex items-center justify-between p-3 border border-gray-200 dark:border-gray-700 rounded-lg gap-3">
            <div>
              <Label className="dark:text-white font-medium">Finalizar Atendimento Move Ticket no Kanban</Label>
              <p className="text-sm text-gray-500 dark:text-gray-400">Quando ativo, ao encerrar um atendimento o ticket é movido automaticamente para a coluna "Fechados" no Kanban</p>
            </div>
            <Switch
              checked={fecharTicketAtualizaKanban}
              onCheckedChange={setFecharTicketAtualizaKanban}
            />
          </div>

          <div className="flex items-center justify-between p-3 border border-gray-200 dark:border-gray-700 rounded-lg gap-3">
            <div>
              <Label className="dark:text-white font-medium">Usuário Pode Mover Ticket no Kanban</Label>
              <p className="text-sm text-gray-500 dark:text-gray-400">Permite que usuários com perfil User movam tickets entre colunas do Kanban pelo atendimento. Admins sempre podem</p>
            </div>
            <Switch
              checked={usuarioPodeMoverKanban}
              onCheckedChange={setUsuarioPodeMoverKanban}
            />
          </div>
        </TabsContent>

        <TabsContent value="privado" className="space-y-3 mt-0">
          <p className="text-sm text-gray-500 dark:text-gray-400">Mensagens automáticas para o contato que inicia uma conversa privada.</p>
          <div className="flex items-center justify-between p-3 border border-gray-200 dark:border-gray-700 rounded-lg gap-3">
            <div className="flex-1">
              <Label className="dark:text-white font-medium">Ativar Mensagem de Boas-Vindas</Label>
              <p className="text-sm text-gray-500 dark:text-gray-400">Enviar mensagem automática quando um contato iniciar uma conversa</p>
            </div>
            <Switch
              checked={ativarMensagemBoasVindas}
              onCheckedChange={setAtivarMensagemBoasVindas}
            />
          </div>

          {ativarMensagemBoasVindas && (
            <>
              <div>
                <Label htmlFor="mensagemBoasVindas" className="dark:text-white">Mensagem de Boas-Vindas</Label>
                <Textarea
                  id="mensagemBoasVindas"
                  value={formValues.mensagemBoasVindas || ''}
                  spellCheck={true}
                  lang="pt-BR"
                  onChange={(e) => handleChange('mensagemBoasVindas', e.target.value)}
                  className="mt-1 dark:bg-slate-700 dark:text-white dark:border-gray-600"
                  placeholder="Ex: {saudacao} {nome_contato}! Seja bem-vindo(a) à {empresa}. Atendimento: {nome_atendente}"
                  rows={4}
                />
                <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
                  Variáveis disponíveis: {'{saudacao}'}, {'{nome_contato}'}, {'{nome_atendente}'}, {'{empresa}'}
                </p>
              </div>

              <div className="flex items-center justify-between p-3 border border-gray-200 dark:border-gray-700 rounded-lg gap-3">
                <div className="flex-1">
                  <Label className="dark:text-white font-medium">Enviar Apenas para Novos Contatos</Label>
                  <p className="text-sm text-gray-500 dark:text-gray-400">
                    {enviarApenasParaNovosContatos
                      ? "Enviar apenas quando for o primeiro contato dessa pessoa"
                      : "Enviar para todos os novos atendimentos (padrão)"}
                  </p>
                </div>
                <Switch
                  checked={enviarApenasParaNovosContatos}
                  onCheckedChange={setEnviarApenasParaNovosContatos}
                />
              </div>
            </>
          )}
        </TabsContent>

        <TabsContent value="grupos" className="space-y-3 mt-0">
          <p className="text-sm text-gray-500 dark:text-gray-400">Valem para conversas de grupos do WhatsApp.</p>
          <div className="flex items-center justify-between p-3 border border-gray-200 dark:border-gray-700 rounded-lg gap-3">
            <div>
              <Label className="dark:text-white font-medium">Permitir Transferência de Grupos</Label>
              <p className="text-sm text-gray-500 dark:text-gray-400">Permitir que atendimentos de grupos sejam transferidos para outros atendentes ou filas</p>
            </div>
            <Switch
              checked={permitirTransferenciaGrupos}
              onCheckedChange={setPermitirTransferenciaGrupos}
            />
          </div>

          <div className="flex items-center justify-between p-3 border border-gray-200 dark:border-gray-700 rounded-lg">
            <div>
              <Label className="dark:text-white font-medium">Baixar Mídia de Grupos Automaticamente</Label>
              <p className="text-sm text-gray-500 dark:text-gray-400">Quando ativo, mídias enviadas em grupos são baixadas e salvas assim que a mensagem chega. Quando desativado, a mídia só é baixada quando o atendente clicar em "Baixar" na conversa. Conversas privadas sempre baixam a mídia automaticamente</p>
            </div>
            <Switch
              checked={baixarMidiaGruposAutomaticamente}
              onCheckedChange={setBaixarMidiaGruposAutomaticamente}
            />
          </div>

          <div className="flex items-center justify-between p-3 border border-gray-200 dark:border-gray-700 rounded-lg gap-3">
            <div>
              <Label className="dark:text-white font-medium">Exibir Grupos no Painel de Operações</Label>
              <p className="text-sm text-gray-500 dark:text-gray-400">Quando ativo, tickets de grupos aparecem junto com os de clientes no Painel de Operações. Quando desativado (padrão), o painel mostra apenas atendimentos individuais</p>
            </div>
            <Switch
              checked={exibirGruposNoPainelOperacional}
              onCheckedChange={setExibirGruposNoPainelOperacional}
            />
          </div>

          <div className="flex items-center justify-between p-3 border border-gray-200 dark:border-gray-700 rounded-lg gap-3">
            <div>
              <Label className="dark:text-white font-medium">Contador de Mensagens Não Lidas</Label>
              <p className="text-sm text-gray-500 dark:text-gray-400">Incluir mensagens de grupos no contador da aba do navegador</p>
            </div>
            <Switch
              checked={contadorIncluirGrupos}
              onCheckedChange={setContadorIncluirGrupos}
            />
          </div>

          <div className="flex items-center justify-between p-3 border border-gray-200 dark:border-gray-700 rounded-lg gap-3">
            <div>
              <Label className="dark:text-white font-medium">Excluir Grupo Também Exclui Conversas e Mensagens</Label>
              <p className="text-sm text-gray-500 dark:text-gray-400">Quando ativo, ao excluir um grupo em Gestão de grupos as conversas (tickets), mensagens e mídias dele também são apagadas do sistema, após uma confirmação extra. Quando desativado (padrão), o histórico do grupo é mantido</p>
            </div>
            <Switch
              checked={excluirGrupoApagaTickets}
              onCheckedChange={setExcluirGrupoApagaTickets}
            />
          </div>
        </TabsContent>
      </Tabs>
      <Button
        className="w-full mt-4 dark:bg-slate-700 dark:text-white"
        onClick={saveChatConfig}
        disabled={loading}
      >
        {loading ? 'Salvando...' : 'Salvar Configurações'}
      </Button>
    </Card>
  );

  const renderContactsConfig = () => (
    <Card className="mb-6 p-4 dark:bg-slate-800">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 mb-4">
        <h3 className="text-lg font-medium text-gray-500 dark:text-white">Contatos</h3>
        <div className="flex flex-wrap gap-2">
          {(user.role === 'Admin' || user.role === 'SuperAdmin') && (
            <>
              <input
                type="file"
                accept=".csv,.xlsx"
                onChange={handleImportContatos}
                style={{ display: 'none' }}
                id="import-contatos"
              />
              <label htmlFor="import-contatos">
                <Button variant="outline" className="dark:bg-slate-700 dark:text-white" type="button" onClick={() => document.getElementById('import-contatos')?.click()}>
                  Importar
                </Button>
              </label>
            </>
          )}
          <Button variant="outline" className="dark:bg-slate-700 dark:text-white" onClick={() => handleExportContatos('xlsx')}>
            Exportar Excel
          </Button>
          <Button variant="outline" className="dark:bg-slate-700 dark:text-white" onClick={() => handleExportContatos('csv')}>
            Exportar CSV
          </Button>
          <Button className="dark:bg-slate-700 dark:text-white" onClick={() => handleContatoIsEdit(null)}>
            <Plus className="h-4 w-4 mr-2" />
            Novo Contato
          </Button>
        </div>
      </div>

      <div className="flex items-center gap-2 pb-2">
        <Label htmlFor="filtro-tipo-contato" className="text-sm">Mostrar</Label>
        <select
          id="filtro-tipo-contato"
          className="h-9 rounded-md border bg-background px-3 text-sm"
          value={tipoContato}
          onChange={(e) => { setTipoContato(e.target.value as 'todos' | 'grupos' | 'normais'); setContatosPage(0); }}
        >
          <option value="todos">Todos os contatos</option>
          <option value="grupos">Contatos de grupos (leads)</option>
          <option value="normais">Contatos normais</option>
        </select>
        <span className="text-xs text-muted-foreground">A exportação segue o filtro selecionado.</span>
      </div>

      <ContatosTable
        contatos={contatos}
        loading={loading}
        total={contatosTotal}
        page={contatosPage}
        rowsPerPage={contatosRowsPerPage}
        onPageChange={setContatosPage}
        onRowsPerPageChange={(n) => { setContatosRowsPerPage(n); setContatosPage(0); }}
        onSort={(field, order) => { setContatosSort({ field, order }); setContatosPage(0); }}
        onSearch={(term) => { setSearchContato(term); setContatosPage(0); }}
        onRowClick={() => { }}
        onEdit={handleContatoIsEdit}
        onDelete={(contato) => handleOpenModalConfirm('contato', contato.id)}
        onHistoricoZpro={zproHabilitado ? (contato) => setHistoricoZproContato({ id: contato.id, nome: contato.nome }) : undefined}
        canEdit={true}
      />

      <HistoricoZproDialog
        open={!!historicoZproContato}
        onClose={() => setHistoricoZproContato(null)}
        contatoId={historicoZproContato?.id || null}
        contatoNome={historicoZproContato?.nome}
      />

      {/* Modal de Contato */}
      {showContatoModal && (
        <Dialog open={showContatoModal} onOpenChange={(open) => { setShowContatoModal(open); if (!open) resetContatoForm(); }}>
          <DialogContent className="dark:bg-slate-700">
            <DialogHeader>
              <DialogTitle className="dark:text-white">{contatoIdEdit ? 'Editar Contato' : 'Novo Contato'}</DialogTitle>
              <DialogDescription className="dark:text-white">
                {contatoIdEdit ? 'Atualize os dados do contato' : 'Preencha os dados para criar um novo contato'}
              </DialogDescription>
            </DialogHeader>
            <div className="grid gap-4 py-4">
              <div className="grid grid-cols-1 sm:grid-cols-4 items-start sm:items-center gap-1.5 sm:gap-4">
                <Label htmlFor="telefoneContato" className="dark:text-white">
                  Telefone *
                </Label>
                <Input
                  id="telefoneContato"
                  value={telefoneContato}
                  onChange={(e) => setTelefoneContato(e.target.value)}
                  className="sm:col-span-3 dark:bg-slate-700 dark:text-white"
                  placeholder="5511999999999"
                />
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-4 items-start sm:items-center gap-1.5 sm:gap-4">
                <Label htmlFor="nomeContato" className="dark:text-white">
                  Nome
                </Label>
                <Input
                  id="nomeContato"
                  value={nomeContato}
                  onChange={(e) => setNomeContato(e.target.value)}
                  className="sm:col-span-3 dark:bg-slate-700 dark:text-white"
                  placeholder="Nome do contato"
                />
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-4 items-start sm:items-center gap-1.5 sm:gap-4">
                <Label htmlFor="emailContato" className="dark:text-white">
                  Email
                </Label>
                <Input
                  id="emailContato"
                  type="email"
                  value={emailContato}
                  onChange={(e) => setEmailContato(e.target.value)}
                  className="sm:col-span-3 dark:bg-slate-700 dark:text-white"
                  placeholder="email@exemplo.com"
                />
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-4 items-start sm:items-center gap-1.5 sm:gap-4">
                <Label htmlFor="notasContato" className="dark:text-white">
                  Notas
                </Label>
                <Input
                  id="notasContato"
                  value={notasContato}
                  onChange={(e) => setNotasContato(e.target.value)}
                  className="sm:col-span-3 dark:bg-slate-700 dark:text-white"
                  placeholder="Observações sobre o contato"
                />
              </div>
            </div>
            <DialogFooter>
              <Button
                type="button"
                variant="outline"
                className="dark:text-white dark:bg-slate-700"
                onClick={() => {
                  resetContatoForm();
                  setShowContatoModal(false);
                }}
              >
                Cancelar
              </Button>
              <Button
                type="button"
                onClick={handleSubmitContato}
                disabled={!telefoneContato || loading}
              >
                {loading ? 'Salvando...' : 'Salvar'}
              </Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>
      )}
    </Card>
  );

  const renderTagsConfig = () => (
    <Card className="mb-6 p-4 dark:bg-slate-800">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 mb-4">
        <h3 className="text-lg font-medium text-gray-500 dark:text-white">Tags</h3>
        <Button className="dark:bg-slate-700 dark:text-white" onClick={() => handleTagIsEdit(null)}>
          <Plus className="h-4 w-4 mr-2" />
          Nova Tag
        </Button>
      </div>

      <TagsTable
        tags={tags}
        loading={loading}
        total={tagsTotal}
        page={tagsPage}
        rowsPerPage={tagsRowsPerPage}
        onPageChange={setTagsPage}
        onRowsPerPageChange={(n) => { setTagsRowsPerPage(n); setTagsPage(0); }}
        onSort={(field, order) => { setTagsSort({ field, order }); setTagsPage(0); }}
        onSearch={(term) => { setTagsSearch(term); setTagsPage(0); }}
        onRowClick={() => { }}
        onEdit={handleTagIsEdit}
        onDelete={(tag) => handleOpenModalConfirm('tag', tag.id)}
        canEdit={true}
        showEmpresaColumn={false}
      />

      {/* Modal de tag */}
      {showTagModal && (
        <Dialog open={showTagModal} onOpenChange={(open) => { setShowTagModal(open); if (!open) resetTagForm(); }}>
          <DialogContent className="dark:bg-slate-700">
            <DialogHeader>
              <DialogTitle className="dark:text-white">{tagIdEdit ? 'Editar Tag' : 'Nova Tag'}</DialogTitle>
              <DialogDescription className="dark:text-white">
                {tagIdEdit ? 'Atualize os dados da tag' : 'Preencha os dados para criar uma nova tag'}
              </DialogDescription>
            </DialogHeader>
            {/* Aviso sobre limite do WhatsApp */}
            {tagsTotal >= 20 && !tagIdEdit && (
              <div className="rounded-md bg-amber-50 dark:bg-amber-900/30 border border-amber-200 dark:border-amber-700 px-4 py-3 text-sm">
                <p className="font-medium text-amber-800 dark:text-amber-300">⚠️ Limite do WhatsApp</p>
                <p className="text-amber-700 dark:text-amber-400 mt-1">
                  Você já possui {tagsTotal} tag{tagsTotal > 1 ? 's' : ''} cadastrada{tagsTotal > 1 ? 's' : ''}.
                  O WhatsApp Business tradicional permite no máximo <strong>20 labels</strong> por conta. Tags além desse limite
                  serão salvas no sistema mas <strong>podem não ser sincronizadas</strong> com o WhatsApp.
                </p>
              </div>
            )}
            <div className="grid gap-4 py-4">
              <div className="grid grid-cols-1 sm:grid-cols-4 items-start sm:items-center gap-1.5 sm:gap-4">
                <Label htmlFor="tituloTag" className="dark:text-white">
                  Título *
                </Label>
                <Input
                  id="tituloTag"
                  value={tituloTag}
                  onChange={(e) => setTituloTag(e.target.value)}
                  className="sm:col-span-3 dark:bg-slate-700 dark:text-white"
                  placeholder="Nome da tag"
                />
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-4 items-start sm:items-center gap-1.5 sm:gap-4">
                <Label htmlFor="corTag" className="dark:text-white">
                  Cor
                </Label>
                <div className="sm:col-span-3 flex gap-2 items-center">
                  <Input
                    id="corTag"
                    type="color"
                    value={corTag}
                    onChange={(e) => setCorTag(e.target.value)}
                    className="w-20 h-10 p-1 dark:bg-slate-700"
                  />
                  <Input
                    type="text"
                    value={corTag}
                    onChange={(e) => setCorTag(e.target.value)}
                    className="flex-1 dark:bg-slate-700 dark:text-white"
                    placeholder="#000000"
                  />
                </div>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-4 items-start sm:items-center gap-1.5 sm:gap-4">
                <Label htmlFor="prioridadeTag" className="dark:text-white">
                  Prioridade
                </Label>
                <Select value={prioridadeTag} onValueChange={(value) => setPrioridadeTag(value)}>
                  <SelectTrigger id="prioridadeTag" className="sm:col-span-3 dark:bg-slate-700 dark:text-white">
                    <SelectValue placeholder="Selecione a prioridade" />
                  </SelectTrigger>
                  <SelectContent className="dark:bg-slate-700 dark:text-white">
                    <SelectItem value="baixa">Baixa</SelectItem>
                    <SelectItem value="media">Média</SelectItem>
                    <SelectItem value="alta">Alta</SelectItem>
                    <SelectItem value="urgente">Urgente</SelectItem>
                  </SelectContent>
                </Select>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-4 items-start sm:items-center gap-1.5 sm:gap-4">
                <Label htmlFor="ativoTag" className="dark:text-white">
                  Ativo
                </Label>
                <Switch
                  id="ativoTag"
                  checked={ativoTag}
                  onCheckedChange={setAtivoTag}
                  className="sm:col-span-3"
                />
              </div>
            </div>
            <DialogFooter>
              <Button
                type="button"
                variant="outline"
                className="dark:text-white dark:bg-slate-700"
                onClick={() => {
                  resetTagForm();
                  setShowTagModal(false);
                }}
              >
                Cancelar
              </Button>
              <Button
                type="button"
                onClick={handleSubmitTag}
                disabled={!tituloTag || loading}
              >
                {loading ? 'Salvando...' : 'Salvar'}
              </Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>
      )}
    </Card>
  )

  const renderDisparoEmBlocoConfig = () => (
    <Card className="mb-6 p-4 dark:bg-slate-800">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 mb-4">
        <h3 className="text-lg font-medium text-gray-500 dark:text-white">Disparo em Bloco</h3>
        <div className="flex flex-wrap gap-2">
          <Button className="dark:bg-slate-700 dark:text-white" onClick={() => { setCategoriaEdit({ nome: '' }); setShowCategoriaModal(true); }}>
            <Plus className="h-4 w-4 mr-2" />
            Novo Bloco
          </Button>
        </div>
      </div>
      <p className="text-sm text-gray-500 dark:text-gray-400 mb-4">
        Gerencie os blocos de mensagens. Cada bloco é um conjunto de mensagens rápidas que podem ser enviadas em sequência.
      </p>

      {/* Gerenciar Blocos (Categorias) */}
      <div className="space-y-2 max-h-80 overflow-y-auto px-1 mb-4">
        {categoriasMensagensRapidas.length === 0 ? (
          <p className="text-center text-gray-500 dark:text-gray-400 py-8">
            Nenhum bloco encontrado. Crie um novo bloco para começar.
          </p>
        ) : (
          categoriasMensagensRapidas.map((cat) => (
            <div
              key={cat.id}
              className="flex items-center justify-between p-3 rounded-lg border border-gray-200 dark:border-slate-700 hover:bg-gray-50 dark:hover:bg-slate-700/50"
            >
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-gray-900 dark:text-gray-100 truncate">
                  {cat.nome}
                </p>
                <p className="text-xs text-gray-400 dark:text-gray-500">
                  {cat._count?.blocos || 0} mensagens
                </p>
              </div>
              <div className="flex gap-1 shrink-0 ml-2">
                <Button
                  variant="ghost"
                  size="sm"
                  className="h-8 text-blue-500"
                  onClick={() => handleGerenciarMensagensBloco(cat)}
                  title="Gerenciar mensagens"
                  aria-label="Gerenciar mensagens"
                >
                  <Zap className="h-4 w-4 sm:mr-1" />
                  <span className="hidden sm:inline">Mensagens</span>
                </Button>
                <Button
                  variant="ghost"
                  size="icon"
                  className="h-8 w-8 text-blue-500"
                  onClick={() => {
                    setCategoriaEdit({ id: cat.id, nome: cat.nome });
                    setShowCategoriaModal(true);
                  }}
                  title="Editar"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
                </Button>
                <Button
                  variant="ghost"
                  size="icon"
                  className="h-8 w-8 text-red-500"
                  onClick={() => handleOpenModalConfirm('categoria', cat.id)}
                  title="Excluir"
                >
                  <Trash2 className="h-4 w-4" />
                </Button>
              </div>
            </div>
          ))
        )}
      </div>

      {/* Modal Novo/Editar Bloco (categoria) */}
      {showCategoriaModal && (
        <Dialog open={showCategoriaModal} onOpenChange={(open) => { setShowCategoriaModal(open); if (!open) setCategoriaEdit(null); }}>
          <DialogContent className="sm:max-w-[400px] dark:bg-slate-800">
            <DialogHeader>
              <DialogTitle className="dark:text-white">{categoriaEdit?.id ? 'Editar Bloco' : 'Novo Bloco'}</DialogTitle>
              <DialogDescription className="dark:text-white">
                {categoriaEdit?.id ? 'Atualize os dados do bloco' : 'Crie um novo bloco para agrupar mensagens rápidas'}
              </DialogDescription>
            </DialogHeader>
            <div className="space-y-4 py-4">
              <div className="flex flex-col gap-2">
                <Label htmlFor="nomeBloco" className="dark:text-white">Nome *</Label>
                <Input
                  id="nomeBloco"
                  value={categoriaEdit?.nome || ''}
                  onChange={(e) => setCategoriaEdit({ ...categoriaEdit, nome: e.target.value })}
                  className="dark:bg-slate-700 dark:text-white"
                  placeholder="ex: Boas-vindas"
                />
              </div>
            </div>
            <DialogFooter>
              <Button variant="outline" className="dark:text-white dark:bg-slate-700" onClick={() => { setCategoriaEdit(null); setShowCategoriaModal(false); }}>
                Cancelar
              </Button>
              <Button onClick={handleSubmitCategoria} disabled={!categoriaEdit?.nome || loading}>
                {loading ? 'Salvando...' : 'Salvar'}
              </Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>
      )}

      {/* Modal Gerenciar Mensagens do Bloco */}
      {showGerenciarCategorias && (
        <Dialog open={showGerenciarCategorias} onOpenChange={(open) => { setShowGerenciarCategorias(open); if (!open) setBlocoEditMensagens(null); }}>
          <DialogContent className="sm:max-w-[600px] dark:bg-slate-800 max-h-[90vh] overflow-y-auto">
            <DialogHeader>
              <DialogTitle className="dark:text-white">
                {blocoEditMensagens ? `Mensagens do bloco "${blocoEditMensagens.nome}"` : 'Gerenciar Mensagens do Bloco'}
              </DialogTitle>
              <DialogDescription className="dark:text-white">
                Selecione as mensagens rápidas que farão parte deste bloco
              </DialogDescription>
            </DialogHeader>
            <div className="space-y-2 max-h-60 overflow-y-auto px-1 my-3">
              {loading ? (
                <div className="flex items-center justify-center py-8 text-gray-500">
                  Carregando mensagens...
                </div>
              ) : mensagensRapidas.length === 0 ? (
                <p className="text-center text-gray-500 dark:text-gray-400 py-8">
                  Nenhuma mensagem rápida encontrada. Crie mensagens rápidas primeiro.
                </p>
              ) : (
                mensagensRapidas.map((msg: any) => {
                  const blocoIds = blocoEditMensagens?.id ? (blocoEditMensagensMsgIds || []) : [];
                  const isSelected = blocoIds.includes(msg.id);
                  return (
                    <div
                      key={msg.id}
                      className={`flex items-center gap-3 p-3 rounded-lg border cursor-pointer transition-colors ${
                        isSelected
                          ? 'border-blue-400 bg-blue-50 dark:border-blue-600 dark:bg-blue-900/20'
                          : 'border-gray-200 dark:border-slate-700 hover:bg-gray-50 dark:hover:bg-slate-700/50'
                      }`}
                      onClick={() => {
                        const blocoId = blocoEditMensagens?.id;
                        if (!blocoId) return;
                        const currentIds = blocoEditMensagensMsgIds || [];
                        const newIds = isSelected
                          ? currentIds.filter((id: string) => id !== msg.id)
                          : [...currentIds, msg.id];
                        setBlocoEditMensagensMsgIds(newIds);
                      }}
                    >
                      <div className={`w-5 h-5 rounded border-2 flex items-center justify-center transition-colors ${
                        isSelected
                          ? 'bg-blue-500 border-blue-500'
                          : 'border-gray-300 dark:border-gray-500'
                      }`}>
                        {isSelected && (
                          <svg className="w-3 h-3 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                          </svg>
                        )}
                      </div>
                      <div className="flex-1 min-w-0">
                        <p className="text-sm font-medium text-gray-900 dark:text-gray-100 truncate">
                          /{msg.chave}
                          {msg.anexos?.length ? (
                            <span className="text-blue-500 text-xs ml-1.5 font-normal">
                              ({msg.anexos.length} anexo{msg.anexos.length > 1 ? 's' : ''})
                            </span>
                          ) : null}
                        </p>
                        <p className="text-xs text-gray-500 dark:text-gray-400 truncate">
                          {msg.mensagem || '(sem texto)'}
                        </p>
                      </div>
                    </div>
                  );
                })
              )}
            </div>
            <DialogFooter className="gap-2">
              <Button variant="outline" className="dark:text-white dark:bg-slate-700" onClick={() => { setShowGerenciarCategorias(false); setBlocoEditMensagens(null); }}>
                Cancelar
              </Button>
              <Button onClick={handleSalvarMensagensBloco} disabled={!blocoEditMensagens || loading}>
                {loading ? 'Salvando...' : 'Salvar'}
              </Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>
      )}
    </Card>
  );

  const renderMensagensRapidasConfig = () => (
    <Card className="mb-6 p-4 dark:bg-slate-800">
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 mb-4">
          <h3 className="text-lg font-medium text-gray-500 dark:text-white">Mensagens Rápidas</h3>
          <div className="flex flex-wrap gap-2">
            <Button className="dark:bg-slate-700 dark:text-white" onClick={() => handleMensagemRapidaIsEdit(null)}>
              <Plus className="h-4 w-4 mr-2" />
              Nova Mensagem
            </Button>
          </div>
        </div>

        <MensagensRapidasTable
        mensagens={mensagensRapidas}
        loading={loading}
        total={mensagensRapidasTotal}
        page={mensagensRapidasPage}
        rowsPerPage={mensagensRapidasRowsPerPage}
        onPageChange={setMensagensRapidasPage}
        onRowsPerPageChange={setMensagensRapidasRowsPerPage}
        onSort={(field, order) => setMensagensRapidasSort({ field, order })}
        onSearch={setMensagensRapidasSearch}
        onEdit={handleMensagemRapidaIsEdit}
        onDelete={(mensagem) => handleOpenModalConfirm('mensagemRapida', mensagem.id)}
        canEdit={true}
      />

      {/* Modal de mensagem rápida */}
      {showMensagemRapidaModal && (
        <Dialog open={showMensagemRapidaModal} onOpenChange={(open) => { setShowMensagemRapidaModal(open); if (!open) { setMensagemRapidaEdit(null); setAnexosMensagemRapida([]); } }}>
          <DialogContent className="sm:max-w-[600px] dark:bg-slate-800 max-h-[90vh] overflow-y-auto">
            <DialogHeader>
              <DialogTitle className="dark:text-white">{mensagemRapidaEdit ? 'Editar Mensagem Rápida' : 'Nova Mensagem Rápida'}</DialogTitle>
              <DialogDescription className="dark:text-white">
                {mensagemRapidaEdit ? 'Atualize os dados da mensagem rápida' : 'Preencha os dados para criar uma nova mensagem rápida'}
              </DialogDescription>
            </DialogHeader>
            <div className="space-y-4 py-4">
              <div className="flex flex-col gap-2">
                <Label htmlFor="chaveMensagemRapida" className="dark:text-white">
                  Chave *
                </Label>
                <div className="flex items-center space-x-2">
                  <span className="text-sm text-gray-500 dark:text-gray-400">/</span>
                  <Input
                    id="chaveMensagemRapida"
                    value={mensagemRapidaEdit?.chave || ''}
                    onChange={(e) => {
                      const mensagem = mensagemRapidaEdit || { chave: '', mensagem: '', ativa: true, categoriaId: null };
                      setMensagemRapidaEdit({ ...mensagem, chave: e.target.value });
                    }}
                    className="flex-1 dark:bg-slate-700 dark:text-white"
                    placeholder="ex: saudacao"
                  />
                </div>
              </div>

              <div className="flex flex-col gap-2">
                <Label htmlFor="blocosMensagemRapida" className="dark:text-white">
                  Blocos
                </Label>
                <SelectWithSearch
                  options={categoriasMensagensRapidas.map((cat: any) => ({
                    value: cat.id,
                    label: cat.nome
                  }))}
                  value={categoriasMensagensRapidas
                    .filter((cat: any) => (mensagemRapidaEdit?.blocoIds || mensagemRapidaEdit?.blocos?.map((b: any) => b.blocoId || b.bloco?.id) || []).includes(cat.id))
                    .map((cat: any) => ({ value: cat.id, label: cat.nome }))}
                  onChange={(selected) => {
                    const mensagem = mensagemRapidaEdit || { chave: '', mensagem: '', ativa: true, blocoIds: [] };
                    setMensagemRapidaEdit({ ...mensagem, blocoIds: selected.map((s: any) => s.value) });
                  }}
                  placeholder="Selecione os blocos..."
                  emptyMessage="Nenhum bloco encontrado"
                  className="w-full"
                />
                <p className="text-[11px] text-gray-500 dark:text-gray-400">
                  A mensagem pode pertencer a múltiplos blocos.
                </p>
              </div>

              <div className="flex flex-col gap-2">
                <Label htmlFor="mensagemRapida" className="dark:text-white">
                  Mensagem
                </Label>
                <Textarea
                  id="mensagemRapida"
                  value={mensagemRapidaEdit?.mensagem || ''}
                  onChange={(e) => {
                    const mensagem = mensagemRapidaEdit || { chave: '', mensagem: '', ativa: true, categoriaId: null, ordem: 0 };
                    setMensagemRapidaEdit({ ...mensagem, mensagem: e.target.value });
                  }}
                  className="min-h-[120px] dark:bg-slate-700 dark:text-white"
                  placeholder="Olá {nome_atendente}, seja bem-vindo(a) à {empresa}!"
                  spellCheck={true}
                  lang="pt-BR"
                />
              </div>

              <div className="flex flex-col gap-2">
                <div className="flex items-center justify-between gap-3">
                  <Label className="dark:text-white">Anexos</Label>
                  <Button type="button" variant="outline" size="sm" onClick={handleAddAnexo} className="dark:text-white dark:bg-slate-700">
                    <Plus className="h-4 w-4 mr-1" /> Adicionar Anexo
                  </Button>
                </div>
                {anexosMensagemRapida.map((anexo, index) => (
                  <div key={index} className="flex gap-2 items-start p-2 border border-gray-200 dark:border-slate-600 rounded">
                    <div className="flex-1 space-y-1">
                      <div className="flex flex-col sm:flex-row sm:items-center gap-2">
                        {anexo.url ? (
                          <span className="text-xs text-gray-600 dark:text-gray-300 truncate flex-1">
                            <span className="font-medium">{anexo.nome}</span>
                          </span>
                        ) : (
                          <span className="text-xs text-red-500 flex-1">Arquivo pendente</span>
                        )}
                        <input
                          type="file"
                          className="w-full min-w-0 sm:w-auto text-xs text-gray-500 dark:text-gray-400 file:mr-2 file:py-1 file:px-3 file:rounded file:border-0 file:text-xs file:bg-slate-100 dark:file:bg-slate-600 file:text-slate-700 dark:file:text-slate-200 hover:file:bg-slate-200 dark:hover:file:bg-slate-500"
                          onChange={(e) => handleAnexoFileSelect(index, e)}
                        />
                      </div>
                      <Select
                        value={anexo.tipo || 'documento'}
                        onValueChange={(value) => handleAnexoChange(index, 'tipo', value)}
                      >
                        <SelectTrigger className="dark:bg-slate-700 dark:text-white text-sm">
                          <SelectValue />
                        </SelectTrigger>
                        <SelectContent className="dark:bg-slate-700 dark:text-white">
                          <SelectItem value="documento">Documento</SelectItem>
                          <SelectItem value="imagem">Imagem</SelectItem>
                          <SelectItem value="video">Vídeo</SelectItem>
                          <SelectItem value="audio">Áudio</SelectItem>
                        </SelectContent>
                      </Select>
                    </div>
                    <Button
                      type="button"
                      variant="ghost"
                      size="icon"
                      onClick={() => handleRemoveAnexo(index)}
                      className="text-red-500 hover:text-red-700"
                    >
                      <Trash2 className="h-4 w-4" />
                    </Button>
                  </div>
                ))}
                {anexosMensagemRapida.length === 0 && (
                  <p className="text-xs text-gray-500 dark:text-gray-400">Nenhum anexo adicionado.</p>
                )}
              </div>

              <div className="flex items-center justify-between gap-3">
                <Label htmlFor="ativaMensagemRapida" className="dark:text-white">
                  Ativa
                </Label>
                <Switch
                  id="ativaMensagemRapida"
                  checked={mensagemRapidaEdit?.ativa ?? true}
                  onCheckedChange={(checked) => {
                    const mensagem = mensagemRapidaEdit || { chave: '', mensagem: '', ativa: true, categoriaId: null };
                    setMensagemRapidaEdit({ ...mensagem, ativa: checked });
                  }}
                />
              </div>

              <div className="text-xs text-gray-500 dark:text-gray-400">
                <p>Variáveis disponíveis: {'{nome_atendente}'}, {'{empresa}'}, {'{nome_contato}'}, {'{saudacao}'}</p>
                <p>Estas serão substituídas automaticamente quando usar a mensagem rápida no chat.</p>
              </div>
            </div>
            <DialogFooter>
              <Button
                type="button"
                variant="outline"
                className="dark:text-white dark:bg-slate-700"
                onClick={() => {
                  setMensagemRapidaEdit(null);
                  setAnexosMensagemRapida([]);
                  setShowMensagemRapidaModal(false);
                }}
              >
                Cancelar
              </Button>
              <Button
                type="button"
                onClick={handleSubmitMensagemRapida}
                disabled={!mensagemRapidaEdit?.chave || (!mensagemRapidaEdit?.mensagem && anexosMensagemRapida.length === 0) || loading}
              >
                {loading ? 'Salvando...' : 'Salvar'}
              </Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>
      )}

    </Card>
  )

  const renderNotificationsSoundsConfig = () => (
    <Card className="mb-6 p-4 dark:bg-slate-800">
      <h3 className="text-lg font-medium mb-4 text-gray-500 dark:text-white">Notificações Sonoras</h3>
      <div className="space-y-4">
        <div className="flex items-center justify-between gap-3">
          <div>
            <Label className="dark:text-white">Habilitar Sons</Label>
            <p className="text-sm text-gray-500 dark:text-gray-400">Ativar notificações sonoras</p>
          </div>
          <Switch
            checked={formValues.notificacoes?.som || false}
            onCheckedChange={(checked) => handleNestedChange('notificacoes', 'som', checked)}
          />
        </div>
        <div>
          <Label className="dark:text-white">Volume</Label>
          <Input type="range" min="0" max="100" defaultValue="50" className="mt-1 dark:bg-slate-700" />
        </div>
        <div>
          <Label className="dark:text-white">Som de Notificação</Label>
          <Select defaultValue="default">
            <SelectTrigger className="w-full mt-1 dark:bg-slate-700 dark:text-white">
              <SelectValue />
            </SelectTrigger>
            <SelectContent className="dark:bg-slate-700 dark:text-white">
              <SelectItem value="default">Padrão</SelectItem>
              <SelectItem value="beep">Beep</SelectItem>
              <SelectItem value="chime">Chime</SelectItem>
              <SelectItem value="notification">Notification</SelectItem>
            </SelectContent>
          </Select>
        </div>
        <Button className="w-full dark:bg-slate-700 dark:text-white">Salvar Configurações</Button>
      </div>
    </Card>
  );

  const renderNotificationsDesktopConfig = () => (
    <Card className="mb-6 p-4 dark:bg-slate-800">
      <h3 className="text-lg font-medium mb-4 text-gray-500 dark:text-white">Notificações Desktop</h3>
      <div className="space-y-4">
        <div className="flex items-center justify-between gap-3">
          <div>
            <Label className="dark:text-white">Habilitar Notificações Desktop</Label>
            <p className="text-sm text-gray-500 dark:text-gray-400">Mostrar notificações na área de trabalho</p>
          </div>
          <Switch
            checked={formValues.notificacoes?.desktop || false}
            onCheckedChange={(checked) => handleNestedChange('notificacoes', 'desktop', checked)}
          />
        </div>
        <div className="flex items-center justify-between gap-3">
          <div>
            <Label className="dark:text-white">Novo Atendimento</Label>
            <p className="text-sm text-gray-500 dark:text-gray-400">Notificar quando houver novo atendimento</p>
          </div>
          <Switch
            checked={formValues.notificacoes?.novoAtendimento || false}
            onCheckedChange={(checked) => handleNestedChange('notificacoes', 'novoAtendimento', checked)}
          />
        </div>
        <div className="flex items-center justify-between gap-3">
          <div>
            <Label className="dark:text-white">Mensagem Recebida</Label>
            <p className="text-sm text-gray-500 dark:text-gray-400">Notificar quando receber nova mensagem</p>
          </div>
          <Switch
            checked={formValues.notificacoes?.mensagemRecebida || false}
            onCheckedChange={(checked) => handleNestedChange('notificacoes', 'mensagemRecebida', checked)}
          />
        </div>
        <Button className="w-full dark:bg-slate-700 dark:text-white">Salvar Configurações</Button>
      </div>
    </Card>
  );

  const renderNotificationsEmailConfig = () => (
    <Card className="mb-6 p-4 dark:bg-slate-800">
      <h3 className="text-lg font-medium mb-4 text-gray-500 dark:text-white">Notificações por Email</h3>
      <div className="space-y-4">
        <div className="flex items-center justify-between gap-3">
          <div>
            <Label className="dark:text-white">Habilitar Notificações por Email</Label>
            <p className="text-sm text-gray-500 dark:text-gray-400">Receber notificações por email</p>
          </div>
          <Switch
            checked={formValues.notificacoes?.email || false}
            onCheckedChange={(checked) => handleNestedChange('notificacoes', 'email', checked)}
          />
        </div>
        <div>
          <Label htmlFor="emailNotificacao" className="dark:text-white">Email para Notificações</Label>
          <Input
            id="emailNotificacao"
            type="email"
            placeholder="seu@email.com"
            className="mt-1 dark:bg-slate-700 dark:text-white"
          />
        </div>
        <div className="flex items-center justify-between gap-3">
          <div>
            <Label className="dark:text-white">Atendimento Transferido</Label>
            <p className="text-sm text-gray-500 dark:text-gray-400">Notificar quando atendimento for transferido</p>
          </div>
          <Switch
            checked={formValues.notificacoes?.atendimentoTransferido || false}
            onCheckedChange={(checked) => handleNestedChange('notificacoes', 'atendimentoTransferido', checked)}
          />
        </div>
        <div className="flex items-center justify-between gap-3">
          <div>
            <Label className="dark:text-white">Atendimento Encerrado</Label>
            <p className="text-sm text-gray-500 dark:text-gray-400">Notificar quando atendimento for encerrado</p>
          </div>
          <Switch
            checked={formValues.notificacoes?.atendimentoEncerrado || false}
            onCheckedChange={(checked) => handleNestedChange('notificacoes', 'atendimentoEncerrado', checked)}
          />
        </div>
        <Button className="w-full dark:bg-slate-700 dark:text-white">Salvar Configurações</Button>
      </div>
    </Card>
  );

  const renderInstanceConfig = () => (
    <Card className="mb-6 p-4 dark:bg-slate-800">
      <h3 className="text-lg font-medium mb-4 text-gray-500 dark:text-white">{t('channels.title')}</h3>
      <div className="mb-4">
        <InstanceApiConnection />
      </div>
    </Card>
  );

  const renderN8nConfig = () => (
    <Card className="mb-6 p-4 dark:bg-slate-800">
      <h3 className="text-lg font-medium mb-4 text-gray-500 dark:text-white">Integração N8N</h3>

      <div className="space-y-6">
        {/* Habilitar Integração */}
        <div className="flex items-center justify-between gap-3">
          <div>
            <Label className="dark:text-white">Habilitar Integração</Label>
            <p className="text-sm text-gray-500 dark:text-gray-400">Ativar integração com N8N para automação</p>
          </div>
          <Switch
            checked={n8nConfig.enabled}
            onCheckedChange={(checked) => setN8nConfig(prev => ({ ...prev, enabled: checked }))}
          />
        </div>

        {/* URL do Webhook */}
        <div>
          <Label htmlFor="n8nWebhookUrl" className="dark:text-white">URL do Webhook N8N</Label>
          <Input
            id="n8nWebhookUrl"
            type="url"
            placeholder="https://seu-n8n.com/webhook/sinticket"
            value={n8nConfig.webhookUrl}
            onChange={(e) => setN8nConfig(prev => ({ ...prev, webhookUrl: e.target.value }))}
            className="mt-1 dark:bg-slate-700 dark:text-white"
            disabled={!n8nConfig.enabled}
          />
          <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
            URL do webhook no N8N para receber eventos do Sinticket
          </p>
        </div>

        {/* Segredo do Webhook */}
        <div>
          <Label htmlFor="n8nWebhookSecret" className="dark:text-white">Segredo do Webhook</Label>
          <Input
            id="n8nWebhookSecret"
            type="password"
            placeholder="Segredo para assinatura HMAC (opcional)"
            value={n8nConfig.webhookSecret}
            onChange={(e) => setN8nConfig(prev => ({ ...prev, webhookSecret: e.target.value }))}
            className="mt-1 dark:bg-slate-700 dark:text-white"
            disabled={!n8nConfig.enabled}
          />
          <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
            Assina os eventos que o Sinticket <strong>envia</strong> ao N8N (header <code className="text-[11px]">X-Sinticket-Signature</code>, HMAC-SHA256). Deixe vazio para não assinar.
          </p>
        </div>

        {/* API Key */}
        <div>
          <div className="flex items-center justify-between gap-2">
            <Label htmlFor="n8nApiKey" className="dark:text-white">API Key do N8N</Label>
            <Button
              type="button"
              variant="outline"
              size="sm"
              onClick={gerarN8nApiKey}
              disabled={gerandoN8nKey || !n8nConfig.enabled}
              className="dark:text-white dark:bg-slate-700 dark:hover:bg-slate-600"
            >
              {gerandoN8nKey ? 'Gerando...' : (n8nConfig.apiKey === '***' ? 'Rotacionar' : 'Gerar API Key')}
            </Button>
          </div>
          <Input
            id="n8nApiKey"
            type={revelarN8nKey ? 'text' : 'password'}
            placeholder="API Key para o N8N acessar este sistema"
            value={n8nConfig.apiKey}
            onChange={(e) => setN8nConfig(prev => ({ ...prev, apiKey: e.target.value }))}
            className="mt-1 dark:bg-slate-700 dark:text-white"
            disabled={!n8nConfig.enabled}
          />
          <div className="flex items-center gap-2 mt-1">
            <p className="text-xs text-gray-500 dark:text-gray-400 flex-1">
              Autentica as chamadas <span className="font-mono">N8N → Sinticket</span> no header <code className="text-[11px]">X-N8N-API-Key</code>. Ela também define quais tickets o N8N enxerga.
            </p>
            {n8nConfig.apiKey && (
              <Button
                type="button"
                variant="ghost"
                size="sm"
                onClick={() => setRevelarN8nKey(v => !v)}
                className="text-gray-500 dark:text-gray-300 h-7 px-2"
              >
                {revelarN8nKey ? 'Ocultar' : 'Ver'}
              </Button>
            )}
          </div>
        </div>

        {/* Botões de Ação */}
        <div className="flex flex-wrap gap-3 pt-4">
          <Button
            onClick={saveN8nConfig}
            disabled={loadingN8n || !n8nConfig.enabled}
            className="dark:bg-blue-600 dark:hover:bg-blue-700"
          >
            {loadingN8n ? 'Salvando...' : 'Salvar Configurações'}
          </Button>

          <Button
            variant="outline"
            onClick={testN8nConfig}
            disabled={testingN8n || !n8nConfig.enabled || !n8nConfig.webhookUrl}
            className="dark:text-white dark:bg-slate-700 dark:hover:bg-slate-600"
          >
            {testingN8n ? 'Testando...' : 'Testar Webhook'}
          </Button>
        </div>

        {/* Informações Adicionais */}
        <div className="bg-blue-50 dark:bg-blue-900/20 p-4 rounded-lg break-words">
          <h4 className="font-medium text-blue-900 dark:text-blue-100 mb-2">Como configurar:</h4>
          <ol className="text-sm text-blue-800 dark:text-blue-200 space-y-1 list-decimal list-inside">
            <li>No N8N, crie um webhook e cole a <strong>URL do Webhook</strong> acima</li>
            <li>Clique em <strong>Gerar API Key</strong> e copie a chave (ela só aparece uma vez)</li>
            <li>No N8N, adicione o header <code className="text-[11px]">X-N8N-API-Key</code> com essa chave em cada nó HTTP Request para <span className="font-mono">/api/n8n/api</span></li>
            <li>Se configurou um Segredo, valide o header <code className="text-[11px]">X-Sinticket-Signature</code> antes de processar o evento</li>
            <li>Teste a recepção com o botão "Testar Webhook"</li>
          </ol>
          <p className="text-sm text-blue-800 dark:text-blue-200 mt-2">
            Endpoints disponíveis: <span className="font-mono text-xs">POST /api/n8n/api/mensagens</span>,{' '}
            <span className="font-mono text-xs">GET /api/n8n/api/tickets/:id</span>,{' '}
            <span className="font-mono text-xs">GET /api/n8n/api/tickets/por-telefone</span>,{' '}
            <span className="font-mono text-xs">POST /api/n8n/api/tickets/atribuir</span>,{' '}
            <span className="font-mono text-xs">GET /api/n8n/api/filas</span>
          </p>
          <p className="text-sm text-blue-800 dark:text-blue-200 mt-2">
            A documentação completa, com exemplos de cURL, está em <span className="font-mono text-xs">docs/N8N_Integration_Guide.md</span>.
          </p>
        </div>
      </div>
    </Card>
  );

  const renderDefaultConfig = () => (
    <div className="flex-1 flex items-center justify-center p-10 relative h-full">
      <img src={SintisLogo} alt="Sintis" className="absolute top-0 left-0 opacity-50 max-w-lg" />
      <div className="text-center max-w-md">
        <h1 className="text-2xl text-gray-500 dark:text-gray-400 font-light mb-3">{t('settings.selectOption')}</h1>
        <p className="text-gray-500 dark:text-gray-400 text-sm mb-8">
          {t('settings.selectOptionDesc')}
        </p>
      </div>
    </div>
  );

  const renderSuperAdminConfig = () => {
    // Verificar se o usuário é SuperAdmin
    if (user.role !== 'SuperAdmin') {
      return (
        <Card className="mb-6 p-4 dark:bg-slate-800">
          <div className="text-center">
            <h3 className="text-lg font-medium text-red-500 dark:text-red-400">Acesso Negado</h3>
            <p className="text-gray-500 dark:text-gray-400 mt-2">
              Apenas usuários SuperAdmin têm acesso a esta funcionalidade.
            </p>
          </div>
        </Card>
      );
    }

    return <SuperAdminSqlQuery />;
  };

  const renderMetaProviderConfig = () => {
    if (user.role !== 'SuperAdmin') {
      return (
        <Card className="mb-6 p-4 dark:bg-slate-800">
          <div className="text-center">
            <h3 className="text-lg font-medium text-red-500 dark:text-red-400">Acesso Negado</h3>
            <p className="text-gray-500 dark:text-gray-400 mt-2">
              Apenas usuários SuperAdmin têm acesso a esta funcionalidade.
            </p>
          </div>
        </Card>
      );
    }

    return <MetaProviderConfigForm />;
  };

  const renderFormByCategory = () => {
    console.log('[FORMCONFIG] renderFormByCategory - category.id=', category?.id, '| category.label=', category?.label, '| all keys:', Object.keys(category));
    // Handle specific subcategories first
    switch (category.id) {
      // General subcategories
      case 'tenants':
      case 'users':
      case 'queues':
        return renderGeneralConfig(category);
      case 'session':
        return <ConfiguracaoSessaoConfig />;
      case 'painel-tv':
        return <PainelTvConfig />;

      // Appearance subcategories
      case 'theme':
        return renderThemeConfig();
      case 'colors':
        return renderColorsConfig();
      case 'logo':
        return renderLogoConfig();

      // Business hours subcategories
      case 'business-hours':
        return <HorarioAtendimentoConfig />;

      // Chat subcategories
      case 'files':
        return renderFilesConfig();
      case 'configurations':
        return renderChatConfigurationsConfig();
      case 'contacts':
        return renderContactsConfig();
      case 'tags':
        return renderTagsConfig();
      case 'mensagens-rapidas':
        return renderMensagensRapidasConfig();
      case 'disparo-em-bloco':
        return renderDisparoEmBlocoConfig();
      case 'disparo-automatico':
        return (
          <Card className="mb-6 p-4 dark:bg-slate-800">
            <MensagensAgendadasTable />
          </Card>
        );

      // SuperAdmin
      case 'superadmin':
        return renderSuperAdminConfig();
      case 'meta-provider-config':
        return renderMetaProviderConfig();
      case 'retencao-midias':
        return user.role === 'SuperAdmin' ? <RetencaoMidiasConfig /> : renderSuperAdminConfig();

      case 'exclusao-dados':
        return user.role === 'SuperAdmin' ? <ExclusaoDadosConfig /> : renderSuperAdminConfig();

      // Notifications subcategories
      case 'notifications-sounds':
        return renderNotificationsSoundsConfig();
      case 'notifications-desktop':
        return renderNotificationsDesktopConfig();
      case 'notifications-email':
        return renderNotificationsEmailConfig();

      // Integrations subcategories
      case 'instances':
        return renderInstanceConfig();
      case 'meta-config':
        return <MetaConfigForm />;
      case 'n8n':
        return renderN8nConfig();
      case 'zpro':
        return (
          <ZproHistoricoConfig
            empresaId={user.empresaId}
            isSuperAdmin={user.role === 'SuperAdmin'}
            canEdit={user.role === 'SuperAdmin'}
          />
        );

      default:
        console.log('[FORMCONFIG] FALLBACK para renderDefaultConfig. category.id não reconhecido:', category?.id);
        return renderDefaultConfig();
    }
  };

  const extractError = (e: any) => e?.response?.data?.message || e?.response?.data?.error || e?.message || String(e);

  const resetEmpresaForm = () => {
    setEmpresaIdEdit('');
    setNomeEmpresa('');
    setPreviewImage(null);
    setCorPrimaria('#3B82F6');
    setCorSecundaria('#10B981');
    setAtivoEmpresa(true);
    setLimiteInstancias('');
    setLimiteUsuarios('');
    setEmpresaFile(null);
    setBackupConfig(defaultConfiguracaoBackup);
  };

  const resetUsuarioForm = () => {
    setUsuarioIdEdit('');
    setNome('');
    setEmail('');
    setSenha('');
    setMostrarSenha(false);
    setRole('');
    setAtivo(false);
    setAcessoConfidencialTotal(false);
    setAcessoConfidencialOriginal(false);
    setFilasUsuario([]);
    setEmpresa('');
  };

  const resetFilaForm = () => {
    setNomeFila('');
    setIndiceFila('');
    setStatusFila(true);
    setFilaIdEdit('');
    setEmpresaIdEdit('');
  };

  const resetContatoForm = () => {
    setContatoIdEdit('');
    setNomeContato('');
    setTelefoneContato('');
    setEmailContato('');
    setNotasContato('');
    setInstanciaContato('');
  };

  const resetTagForm = () => {
    setTagIdEdit('');
    setTituloTag('');
    setCorTag('#3B82F6');
    setPrioridadeTag('');
    setAtivoTag(true);
  };

  const handleTagIsEdit = (tag: any) => {
    setShowTagModal(true);
    if (tag) {
      setTagIdEdit(tag.id);
      setTituloTag(tag.titulo || '');
      setCorTag(tag.cor || '#000000');
      setPrioridadeTag(tag.prioridade || '');
      setAtivoTag(tag.ativo || false);
    }
  };

  const handleMensagemRapidaIsEdit = (mensagem: any) => {
    setShowMensagemRapidaModal(true);
    if (mensagem && mensagem.id) {
      // Converte blocos do formato do backend para blocoIds
      const blocos = mensagem.blocos || [];
      const blocoIds = blocos.map((b: any) => b.bloco?.id || b.blocoId).filter(Boolean);
      setMensagemRapidaEdit({ ...mensagem, blocoIds });
      setAnexosMensagemRapida(Array.isArray(mensagem.anexos) ? mensagem.anexos : []);
    } else {
      setMensagemRapidaEdit({ chave: '', mensagem: '', ativa: true, blocoIds: [], ordem: 0 });
      setAnexosMensagemRapida([]);
    }
  };

  const handleContatoIsEdit = (contato: any) => {
    setShowContatoModal(true);
    if (contato) {
      setContatoIdEdit(contato.id);
      setNomeContato(contato.nome || '');
      setTelefoneContato(contato.telefone);
      setEmailContato(contato.email || '');
      setNotasContato(contato.notas || '');
    }
  };

  const handleSubmitContato = async () => {
    try {
      setLoading(true);
      const empresaId = user.role === 'SuperAdmin' ? empresa : user.empresaId;

      const data = {
        empresaId,
        telefone: telefoneContato,
        nome: nomeContato,
        email: emailContato,
        notas: notasContato,
        instanciaId: instanciaContato || null,
      };

      if (contatoIdEdit) {
        await api.put(`/contatos/${contatoIdEdit}`, data);
        toast({
          title: 'Sucesso',
          description: 'Contato atualizado com sucesso',
        });
      } else {
        await api.post('/contatos', data);
        toast({
          title: 'Sucesso',
          description: 'Contato criado com sucesso',
        });
      }

      await loadContatos();
      resetContatoForm();
      setShowContatoModal(false);
    } catch (e: any) {
      toast({
        title: 'Erro',
        description: extractError(e?.response?.data?.message),
        variant: 'destructive',
      });
    } finally {
      setLoading(false);
    }
  };

  const handleSubmitTag = async () => {
    try {
      setLoading(true);
      const empresaId = user.role === 'SuperAdmin' ? empresa : user.empresaId;

      const data = {
        empresaId,
        titulo: tituloTag,
        cor: corTag,
        prioridade: prioridadeTag ? prioridadeTag : null,
        ativo: ativoTag,
      };

      if (tagIdEdit) {
        await api.put(`/tags/${tagIdEdit}`, data);
        toast({
          title: 'Sucesso',
          description: 'Tag atualizada com sucesso',
        });
      } else {
        await api.post('/tags', data);
        toast({
          title: 'Sucesso',
          description: 'Tag criada com sucesso',
        });
      }

      await loadTags();
      resetTagForm();
      setShowTagModal(false);
    } catch (e: any) {
      toast({
        title: 'Erro',
        description: extractError(e?.response?.data?.message),
        variant: 'destructive',
      });
    } finally {
      setLoading(false);
    }
  };

  const handleSubmitMensagemRapida = async () => {
    try {
      setLoading(true);
      const empresaId = user.role === 'SuperAdmin' ? empresa : user.empresaId;

      const data: any = {
        empresaId,
        chave: mensagemRapidaEdit?.chave,
        mensagem: mensagemRapidaEdit?.mensagem || '',
        ativa: mensagemRapidaEdit?.ativa ?? true,
        blocoIds: mensagemRapidaEdit?.blocoIds || [],
        ordem: mensagemRapidaEdit?.ordem ?? 0,
      };

      if (anexosMensagemRapida.length > 0) {
        data.anexos = anexosMensagemRapida;
      }

      if (mensagemRapidaEdit?.id) {
        await api.put(`/mensagens-rapidas/${mensagemRapidaEdit.id}`, data);
        toast({
          title: 'Sucesso',
          description: 'Mensagem rápida atualizada com sucesso',
        });
      } else {
        await api.post('/mensagens-rapidas', data);
        toast({
          title: 'Sucesso',
          description: 'Mensagem rápida criada com sucesso',
        });
      }

      await loadMensagensRapidas();
      setMensagemRapidaEdit(null);
      setAnexosMensagemRapida([]);
      setShowMensagemRapidaModal(false);
    } catch (e: any) {
      toast({
        title: 'Erro',
        description: extractError(e?.response?.data?.message),
        variant: 'destructive',
      });
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteContato = async (id: string) => {
    try {
      setLoading(true);
      await api.delete(`/contatos/${id}`);
      toast({
        title: 'Sucesso',
        description: 'Contato excluído com sucesso',
      });
      await loadContatos();
      setShowCancelModal(false);
    } catch (e: any) {
      toast({
        title: 'Erro',
        description: extractError(e?.response?.data?.message),
        variant: 'destructive',
      });
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteMensagemRapida = async (id: string) => {
    try {
      setLoading(true);
      await api.delete(`/mensagens-rapidas/${id}`);
      toast({
        title: 'Sucesso',
        description: 'Mensagem rápida excluída com sucesso',
      });
      await loadMensagensRapidas();
      setShowCancelModal(false);
    } catch (e: any) {
      toast({
        title: 'Erro',
        description: extractError(e?.response?.data?.message),
        variant: 'destructive',
      });
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteTag = async (id: string) => {
    try {
      setLoading(true);
      await api.delete(`/tags/${id}`);
      toast({
        title: 'Sucesso',
        description: 'Tag excluída com sucesso',
      });
      await loadTags();
      setShowCancelModal(false);
    } catch (e: any) {
      toast({
        title: 'Erro',
        description: extractError(e?.response?.data?.message),
        variant: 'destructive',
      });
    } finally {
      setLoading(false);
    }
  };

  const handleImportContatos = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;

    try {
      setLoading(true);
      const empresaId = user.role === 'SuperAdmin' ? empresa : user.empresaId;

      const formData = new FormData();
      formData.append('file', file);

      const response = await api.post(`/contatos/import`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      const { imported = 0, linked = 0, ignored = 0, descartados = 0 } = response.data || {};
      const partes = [`${imported} novo(s)`];
      if (linked) partes.push(`${linked} existente(s) vinculado(s) ao Zpro`);
      if (ignored) partes.push(`${ignored} já existiam`);
      if (descartados) partes.push(`${descartados} linha(s) descartada(s) (grupo, LID ou telefone inválido)`);
      toast({
        title: 'Importação concluída',
        description: partes.join(' · '),
      });

      await loadContatos();
    } catch (e: any) {
      toast({
        title: 'Erro ao importar',
        description: extractError(e?.response?.data?.message),
        variant: 'destructive',
      });
    } finally {
      setLoading(false);
      // Reset input
      event.target.value = '';
    }
  };

  const handleExportContatos = async (format: 'xlsx' | 'csv') => {
    try {
      setLoading(true);

      const response = await api.get(`/contatos/export`, {
        params: { format, tipo: tipoContato },
        responseType: 'blob',
      });

      // Create download link
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `contatos.${format}`);
      document.body.appendChild(link);
      link.click();
      link.remove();

      toast({
        title: 'Sucesso',
        description: 'Contatos exportados com sucesso',
      });
    } catch (e: any) {
      toast({
        title: 'Erro ao exportar',
        description: extractError(e?.response?.data?.message),
        variant: 'destructive',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <ScrollArea className="h-full">
      <div className={category.id ? "h-full p-2 sm:p-4" : "h-full"}>
        {renderFormByCategory()}
        <Dialog open={showCancelModal} onOpenChange={setShowCancelModal}>
          <DialogContent className="dark:bg-slate-700">
            <DialogHeader>
              <DialogTitle className="dark:text-white">Confirmar exclusão</DialogTitle>
              <DialogDescription className="dark:text-white">
                Tem certeza que deseja excluir este item?
              </DialogDescription>
            </DialogHeader>
            <DialogFooter>
              <DialogClose asChild>
                <Button variant="secondary">Cancelar</Button>
              </DialogClose>
              <Button type="button" onClick={() => handleDeleteModalConfirm()}>Confirmar</Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>
        <ExcluirEmpresaModal
          dados={exclusaoCompleta}
          onClose={() => setExclusaoCompleta(null)}
          onExcluida={handleEmpresaExcluidaCompleta}
        />
      </div>
    </ScrollArea>
  );
};

export default FormConfiguracoes;
